import React, { Children, Component } from "react";
import {
  GET_IDEA_URL,
  REVIEW_IDEA_URL,
  UPDATE_IDEA_URL,
  AWAITING_MASTER_BLACKBELT_APPROVAL,
  DISPLAYPROJECTTHEME,
  DELEGATE_IDEA_URL,
  GET_METADATA,
  APPROVED,
  PENDING,
  OTHER_REGIONS,
  SENT_BACK,
  REJECTED,
  DATA_BRIDGE_CAMPAIGN,
  X_POLLINATION_CAMPAIGN,
  ACCESS_TOKEN,
  COMPLETE_STATUS,
  USER_DATA,
  SIGNOFF_CONTENT,
  PPT_CONTENT,
  AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION,
  BI_FORM_DATE,
  GOL_APPROVAL_CONTENT,
  AWAITING_QAULITY_CHECK_REVIEW,
  modelOperationOptions,
  YESORNO,SOLUTIONCOMPLEXITY, REPLICABILITYOPTIONS,
  AI_DOC_LINK, AIFIRST,IMPACTOPTIONS,NO_VD,
  VD_TO_CLIENT,
  VD_TO_GENPACT,
  VD_TO_CLIENT_PLUS_GENPACT,
  IMPACT_TO_GENPACT,
  IMPACT_TO_CLIENT,
  IDEA_ADMIN_UPDATE,AWAITING_PROJECT_APPROVAL,
  CANCEL

} from "../assets/constants/constants";
import Toast from "light-toast";
import Select from "react-select";
import {
  selectValidation as selectStyle,
  textBoxValidation,
} from "../utils/FieldValidation";

import UpdatedSpeech from "./UpdatedSpeech";
import SortByColumn from "../utils/SortByColumns";
import { withRouter } from "react-router-dom";
import ValueDelivery from "../utils/ValueDelivery";
import { Link } from "react-router-dom";




const projectType = [
  {
    value: 0,
    label: "GB",
  },
  {
    value: 1,
    label: "BB",
  },
  {
    value: 2,
    label: "MBB",
  },
];

export class FinalReviewIdeaPage extends Component {
  sessionData = JSON.parse(localStorage.getItem(USER_DATA));
  accessToken = localStorage.getItem(ACCESS_TOKEN);
  constructor(props) {
    super(props);
    const isApprovalPage = `${this.props.location.approval}`;
    let propsData = this.props.location;
    this.state = {
      cancelProjDirect:false,
      cancelComment:"",
      onInitPageTime:"",
      ideaItem: {},
      workflowStatus: "",
      Comment: "",
      finalComment: "",
      accountName: "",
      campaignName: "",
      serviceLineName: "",
      showFinalAdditionalDetails: false,
      workFlowStatusList: [],
      workFlowStatusSelectedOption: null,
      certificationLevelsList: [],
      certLevelsSelectedOption: null,

      transformationLeversList: [],
      transSelectedOption: null,
      digitalProjectTypeList: [],
      digitalProjectTypeSelectedOptions: null,

      methodologyList: [],
      methodologySelectedOptions: null,
      expectedDate: new Date(),
      finalApproveOptionsValue: [
        {
          WorkflowStatusId: 1,
          WorkflowStatusName: "Approved",
        },
        {
          WorkflowStatusId: 2,
          WorkflowStatusName: "Rejected",
        },
        {
          WorkflowStatusId: 3,
          WorkflowStatusName: "Send Back",
        },
      ],
      finalImpactDollar: 0.0,
      finalImpactFTE: 0.0,

      otherTools: "",
      bestClass: false,
      approvalSelectedOption: null,
      selectStyle: {},
      businessImpactMasterList: null,
      businessImpactValueArray: [],
      fteTotal: 0,
      dollarTotal: 0.0,
      summaryArray: [],
      approvalPage: isApprovalPage,
      replicaIndex: [],
      selectStyle: {},
      reviewComments: [],
      propsData: propsData,
      Role: "",
      speechModal: false,
      previousTextForSpeech: "",
      CommentEmpty: false,
      ideaCreatedDate: "",
      showHrefModal: false,
      zeroImpactForLastestBI: false,
      CompletedDate: "",
      showClientFields: false,
      showGOLFields: false,

      // PPT deck
      filename1: "",
      fileType1: "",
      base64File1: "",

      // client sign-off
      signOffFilename: "",
      signOffFileType: "",
      signOffContent: "",

      // gol file
      filename3: "",
      fileType3: "",
      base64File3: "",

      // fpna file
      filename4: "",
      fileType4: "",
      base64File4: "",

      clientName: "",
      clientRole: "",
      clientSignOffDate: "",

      golFilename: "",
      golContent: "",
      golFileType: "",
      golOhr: "",
      golEmail: "",
      golFullname: "",

      fpnaOhr: "",
      fpnaFilename: "",
      fpnaContent: "",
      fpnaFileType: "",
      fpnaName: "",

      submitIdeaCount: 0,
      biThreshold: "",
      awaitingQC: false,

      vrconditiontype: "",
      vrMapping: "",
      vrRegionMapping: "",
      vrVerticalSplit: "",
      vrResult: "",
      IsVDType: "",
      showBBFieldsValue: [],
      appropriateAttachment: false,
      mbbLimit: 50000,
      approvalStatusState: "",
      bbFieldValidationState: "",
      inputDollarValue: "",

      monetizableProjectSelectedOption: null,
      monetizableCheckbox: null,
      monetizableStatus: false,
      showClientApprovalFields: false,

      monetizationStatusSelectedOption: null,
      SowID: "",
      IsVDMonetizable: "",
      MonetizationStatus: "",
      FPnAOHRMonetization: "",
      FPnANameMonetization: "",
      FPnAEmailMonetization: "",
      FPnAFileNameMonetization: "",
      FPnAFileTypeMonetization: "",
      FPnAFileMonetization: "",
      IsSampleCheck: false,

      totalMonetizedFTE: 0,
      totalMonetizedDollar: 0,
      qcCommentLog: false,
      qcComments: [],
      impactChanged: false,
      replicaLatestOptions: [
        { id: 1, label: "1" },
        { id: 2, label: "2" },
        { id: 3, label: "3" },
        { id: 4, label: "4" },
        { id: 5, label: "5" },
      ],
      qcCommentsWithVD: [],
      golFpnaFileDetails: [],

      isFpnaRequired: false,
      displayProjectTheme: false,
      // clustor states starts here
      clusterModal: false,
      projectTypeSelectedOption: null,
      projectIDSelectedOption: null,
      clustorProjects: [],
      guidSelectedOption: null,
      showHirearchy: true,
      showTreeHirearchy: false,
      clusterData: [],
      isClusterSaveDisabled: true,
      clusterOptionSearched: false,

      campaignList: [],
      campaignInsight: "",

      //AI
      ideasAI: [],
      isIdeaReplicable: "",
      IsSolnFeasible:"",
      ldtName:"",
      ldtOHR:"",
      ldtSelectedOption:null,
      mbbName:"",
      mbbOHR:"",
      mbbSelectedOption:null,
      leadNameList:[],
      mbbList:[],


      // productivity
      methodologies: "",
      contractedUploadedOHRCount: 0,
      nonContractedUploadedOHRCount: 0,
      totalOHRUploaded: 0,
      checkProductivityLineItems: false,

      CodersTable: [],
      olderCoderTable: [],
      digitalProjectEnabled: false,
      OtherTools: "",

      allLogs: [],
      campaignUnionQuery:null,

      backFillPopup:false,

       FTEPopup:false


    };
    this.isExceedlimit = false;
    this.isFtePresent = false;
  }

  async componentDidMount() {
    await this.fetchIdea();
    await this.fetchMetadata();
  }
  cancelProject = () => {
    Toast.info(
      "Once cancelled you cannot have the project reinitiated. You will need to start the project from scratch.",
      3000,
      () => { }
    );
    this.setState({
      cancelProjDirect: !this.state.cancelProjDirect,
      cancelComment: "",
    });
  };
  
  handleCancelCommentChange = (e) => {
    let commentChange = e;
    this.setState({
      cancelComment: commentChange,
    });
  };

  submitEvent = () => {
    if(this.state.cancelComment !== "" && this.state.cancelComment && this.state.cancelComment!== null && this.state.cancelComment.length <= 500){
      let param = {};
      if (window.confirm("Are you sure you want to cancel this Idea?")) {
        Toast.loading("Cancellation is in process...", () => { });
        let checkifBiContainsProductivityLineItems = false;
        checkifBiContainsProductivityLineItems = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some(item => item.PValid && item.PValid.length > 0);
          param = {
            OnInitPageTime: this.state.onInitPageTime,
            IdeaName:this.state.ideaItem.IdeaName,
            IdeaId: this.props.location.state,
            IdeaIDAlpha:this.state.ideaItem.IdeaIDAlpha,
            LeanID:this.state.ideaItem.LeanID,
            OwnerName:this.state.ideaItem.OwnerName,
            OwnerEmail:this.state.ideaItem.OwnerEmail,
            BlackBeltUserEmail: this.state.ideaItem.BlackBeltUserEmail,
            ApprovalStatus:CANCEL,
            checkifBiContainsProductivityLineItems: checkifBiContainsProductivityLineItems,
            UpdaterOHR: this.sessionData.profile.oHRId,
            UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
            UpdaterName:
              this.sessionData.profile.lastName +
              ", " +
              this.sessionData.profile.firstName,
            Comment: this.state.cancelComment,
            saveType:"Cancelling Project",
            ProjectStatus:this.state.ideaItem.ApprovalStatus,
            WorkflowStatus:
              this.state.ideaItem.WorkflowStatus, 
            isitalean:true,                                  
            Role: "Mentor",
            updaterAction: CANCEL,
          };
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.accessToken,
          },
          body: JSON.stringify(param),
        };
        fetch(`${IDEA_ADMIN_UPDATE}`, requestOptions)
          .then((response) => {
            return response.json().then((data) => {
              return data;
            });
          })
          .then((data) => {
            if (!data) {
              return;
            }
            Toast.hide();
            Toast.success(
               "Idea has been cancelled successfully.",
              3000,
              () => {
                console.log(JSON.stringify(data));
                let redirectURL = "/review-page";
                if (this.state.approvalPage) {
                  redirectURL =
                    redirectURL + "?page=" + this.state.approvalPage;
                }
                window.location = this.state.admin
                  ? "/view-all-ideas-page"
                  : redirectURL;
              }
            );
          });
      }
    } 
    else {
      if (!this.state.cancelComment || this.state.cancelComment.trim() === "") {
        Toast.fail("Please add reason for cancel request.", 3000);
      } else if (this.state.cancelComment.length > 500) {
        Toast.fail("Comment should not exceed 500 characters.", 3000);
      }
    }
  };    


  fetchMetadata = async () => {
    try {
      const param = {
        EntityType: "",
        EntityName: "",
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
        body: JSON.stringify(param),
      };

      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          this.setState(
            {
              workFlowStatusList: data ? data.WorkflowStatus : [],
              certificationLevelsList: data ? data.CertificationLevels : [],
              transformationLeversList: data ? data.TransformationLevers : [],
              methodologyList: data ? data.Methodologies : [],
              businessImpactMasterList: data ? data.BIMasterDataVerseNew : [],
              biThreshold: data.BIQCThreshold ? data.BIQCThreshold[0] ? data.BIQCThreshold[0].pg_threshold : 0 : 0,
              vrconditiontype: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_vrconditiontype : [] : [],
              vrVerticalMapping: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_vertical ? data.BIQCVRMapping[0].pg_vertical.split("|") : "ALL" : "ALL" : "ALL",
              vrRegionMapping: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_region ? data.BIQCVRMapping[0].pg_region.split("|") : "ALL" : "ALL" : "ALL",
              campaignList: data ? data.Campaigns : [],
              digitalProjectTypeList: data ? data.DigitalProjectTypes : [],
              aiClassificationList: data ? data.AIClassification : [],
            },
            () => {
              if (this.state.ideaItem.CampaignName && this.state.campaignList) {
                this.state.campaignList.map((campaign) => {
                  if (campaign.Campaign === this.state.ideaItem.CampaignName) {
                    this.setState({ campaignInsight: campaign.CampaignDescr }, () => { })
                  }
                })
              }
              this.setSelectedOptions();
            }
          );
        }
      }
    } catch (error) {
      console.log("Error =>", JSON.stringify(error));
      Toast.fail("Error occured while getting metadata idea. Please try again!", 3000, () => { });
      Toast.hide()
    }
  };


  setSelectedOptions = () => {
    this.state.workFlowStatusList.map((item, index) => {
      if (this.state.ideaItem.WorkflowStatus === item.WorkflowStatusName) {
        this.setState({
          workFlowStatusSelectedOption: {
            value: item.WorkflowStatusId,
            label: item.WorkflowStatusName,
          },
        });
      }
      return 1;
    });

    this.state.finalApproveOptionsValue.map((item, index) => {
      if (this.state.ideaItem.ApprovalStatus === item.WorkflowStatusName) {
        this.setState({
          approvalSelectedOption: {
            value: item.WorkflowStatusId,
            label: item.WorkflowStatusName,
          },
        });
      }
      return 1;
    });

    this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
      if (this.state.ideaItem.TLID === item.TLID) {
        this.setState({
          transSelectedOption: {
            value: item.TLID,
            label: item.TransformationLever,
          },
        }, () => {
          this.setToolsMethodologies()
          if (this.state.transSelectedOption && this.state.transSelectedOption.label === "Digital") {
            this.setState({ digitalProjectEnabled: true }, () => { })
          }
        });
      }
      return 1;
    });

    if (this.state.ideaItem.DigitalProjectType) {
      this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
        if (item.DPTypeID === this.state.ideaItem.DPTypeID) {
          this.setState({ digitalProjectTypeSelectedOptions: { value: item.DPTypeID, label: item.DPType }, digitalProjectEnabled: true })
        }
        this.setToolsMethodologies()
      })
    }


    this.state.aiClassificationList && this.state.aiClassificationList.map((item) => {
      if (this.state.ideaItem.AIClassification === item.AIClassification) {
        this.setState({
          aiClassificationListSelectedOption: {
            value: item.RecID,
            label: item.AIClassification,
          },
        }, () => {
          this.setToolsMethodologies()
        });
      }
      return 1;
    });

    

    
  };

  

  setToolsMethodologies = () => {
    let localMethodology = this.state.ideaItem.MethodologyName && this.state.ideaItem.MethodologyName.replace(/[|,]/g, ",")
    localMethodology = localMethodology.split(",");
    let options = [];
    this.state.methodologyList && this.state.methodologyList.map((item, ind) => {
      if (this.state.transSelectedOption && this.state.transSelectedOption.label === item.TransformationLever && item.RecStatus === true && this.state.aiClassificationListSelectedOption?.label === item.AIClassification) {
        if (this.state.digitalProjectTypeSelectedOptions) {
          if (this.state.digitalProjectTypeSelectedOptions.label === item.DigitalProjectType) {
            localMethodology.map((local, index) => {
              if (local === item.Methodology) {
                options.push({ value: item.RecID, label: item.Methodology, sortOrder: item.SOrd || 0 })
              }
            })
          }
        }
        else {
          localMethodology.map((local, index) => {
            if (local === item.Methodology) {
              options.push({ value: item.RecID, label: item.Methodology, sortOrder: item.SOrd || 0 })
            }
          })
        }
      }
    })
    options.sort((a, b) => a.sortOrder - b.sortOrder);
    this.setState({ methodologySelectedOptions: options }, () => {
      //console.log('methodology selected option => ', this.state.methodologySelectedOptions)
    })
  }



  fetchIdea = async () => {
    try {
      Toast.loading("Fetching Idea and Metadata...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          console.log("fetch idea", data);
          Toast.hide()
          this.setState(
            {
              ideaItem: data.ResultSets.Table1[0],
              reviewComments: data.ReviewComments ? data.ReviewComments : [],
              finalReviewComments: data.FinalReviewComments ? data.FinalReviewComments : [],
              workflowStatus: data.ResultSets.Table1[0].WorkflowStatus,
              Comment: data.ResultSets.Table1[0].Comment,

              signOffFilename: data.ResultSets.Table1[0].CustomerSignoffFileName,
              signOffFileType: data.ResultSets.Table1[0].CustomerSignoffType,

              finalComment: data.ResultSets.Table1[0].FinalComments,
              finalImpactDollar: data.ResultSets.Table1[0].FinalImpactDollar,
              finalImpactFTE: data.ResultSets.Table1[0].FinalImpactFTE,
              expectedDate: data.ResultSets.Table1[0].ExpectedFinishDate === null ? new Date() : new Date(data.ResultSets.Table1[0].ExpectedFinishDate),
              otherTools: data.ResultSets.Table1[0].FinalOtherTools,
              bestClass: data.ResultSets.Table1[0].IsBestInClass,

              xPollinationCampaign: data.ResultSets.Table1[0].CampaignName === X_POLLINATION_CAMPAIGN,
              ideaCreatedDate: data.ResultSets.Table1[0].CreatedDate,
              golFilename: data.ResultSets.Table1[0].GOLFileName ? data.ResultSets.Table1[0].GOLFileName : "",

              golFileType: data.ResultSets.Table1[0].GOLFileType,
              fpnaFilename: data.ResultSets.Table1[0].FPnAFileName,

              fpnaFileType: data.ResultSets.Table1[0].FPnAFileType,
              IsVDType: data.ResultSets.Table1[0].VDType,
              fpnaOhr: data.ResultSets.Table1[0] ? data.ResultSets.Table1[0].FPnAOHR : null,
              fpnaName: data.ResultSets.Table1[0] ? data.ResultSets.Table1[0].FPnAName : null,
              IsSampleCheck: data.SampleCheck.Table1[0].IsSampleCheck,
              qcComments: data.QcComments ? data.QcComments : [],
              replicaIndex: data.ResultSets.Table1[0]
                ? data.ResultSets.Table1[0].ReplicabilityIndex
                : null,
              qcCommentsWithVD: data.qcCommentsWithVD ? data.qcCommentsWithVD : [],
              clusterData: data.ClusterData ? data.ClusterData : [],
              
              ideasAI: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0] : [] : [],

              CodersTable: data.CodersTable ? data.CodersTable : [],
              olderCoderTable: data.CodersTable ? data.CodersTable : [],
              OtherTools: data.ResultSets.Table1[0].OtherTools,
              allLogs: data.AllLogs ? data.AllLogs : [],

              campaignUnionQuery: data.CampaignDetails.ResultSets.Table1,
              vdForComponent: data.BIData ? data.BIData : [],

              ProductivityFTE:data.ProductivityFTE ? data.ProductivityFTE:[]


              
            },
            () => {
              Toast.hide()
              if (this.state.ideaItem.ModifiedDate) {
                this.setState({
                  onInitPageTime: this.state.ideaItem.ModifiedDate,
                })
              }

              if (this.state.ideaItem.MBBName && this.state.ideaItem.MBBOHR) {
                this.setState({
                  mbbName: this.state.ideaItem.MBBName,
                  mbbOHR: this.state.ideaItem.MBBOHR,
                  mbbSelectedOption: {
                    label: this.state.ideaItem.MBBName,
                    value: this.state.ideaItem.MBBOHR
                  }
                })
              }
              if (this.state.ideaItem.LDTLeadName && this.state.ideaItem.LDTId) {
                this.setState({
                  ldtName: this.state.ideaItem.LDTLeadName,
                  ldtOHR: this.state.ideaItem.LDTId,
                  ldtSelectedOption: {
                    label: this.state.ideaItem.LDTLeadName,
                    value: this.state.ideaItem.LDTId
                  }
                })
              }
              this.fetchLDTandMBB()

              
              
              if (this.state.clusterData && this.state.clusterData.length > 0) {
                const targetRecID = this.state.ideaItem.LeanID;
                const filteredData = this.state.clusterData.filter(
                  (item) => item.RecAlpha === targetRecID
                );
                let getParentAlpa = "";
                this.state.clusterData.map((item) => {
                  if (item.RecAlpha === targetRecID) {
                    getParentAlpa = item.ParentAlpha;
                  }
                });
                if (getParentAlpa) {
                  this.state.clusterData.map((item) => {
                    if (getParentAlpa === item.RecAlpha) {
                      const selectedOption = {
                        value: 0,
                        label: item.ProjectType,
                      };
                      this.state.projectTypeSelectedOption = selectedOption;
                      this.setState(
                        { projectTypeSelectedOption: selectedOption },
                        () => { }
                      );
                    }
                  });
                }

                if (
                  filteredData &&
                  filteredData.length > 0 &&
                  filteredData !== undefined &&
                  filteredData !== null
                ) {
                  const selectedOption = {
                    value: 0,
                    label: filteredData[0].ParentAlpha,
                  };
                  this.setState(
                    { projectIDSelectedOption: selectedOption },
                    () => {
                      //console.log("project type selected option",this.state.projectTypeSelectedOption)
                      this.setState(
                        { projectIDSelectedOption: selectedOption },
                        () => {
                          if (
                            this.state.projectTypeSelectedOption &&
                            (this.state.projectTypeSelectedOption.label ===
                              null ||
                              this.state.projectTypeSelectedOption.label === "")
                          ) {
                            if (
                              this.state.projectIDSelectedOption.label.startsWith(
                                "GB"
                              )
                            ) {
                              const selectedOptionGB = {
                                value: 0,
                                label: "GB",
                              };
                              this.state.projectTypeSelectedOption =
                                selectedOptionGB;
                              this.setState(
                                { projectTypeSelectedOption: selectedOptionGB },
                                () => {
                                  //console.log(this.state.projectTypeSelectedOption)
                                }
                              );
                            } else {
                              const selectedOptionBB = {
                                value: 0,
                                label: "BB",
                              };
                              this.state.projectTypeSelectedOption =
                                selectedOptionBB;
                              this.setState(
                                { projectTypeSelectedOption: selectedOptionBB },
                                () => {
                                  //console.log(this.state.projectTypeSelectedOption)
                                }
                              );
                            }
                          }
                        }
                      );
                    }
                  );

                  this.setState(
                    {
                      isClusterSaveDisabled: true,
                      displayParentAlpha: filteredData[0].ParentAlpha,
                    },
                    () => { }
                  );
                } else {
                  this.setState({ displayParentAlpha: "" }, () => { });
                }
              } else {
                this.setState({ displayParentAlpha: "" }, () => { });
              }

              if (this.state.ideaItem.CreatedDate) {
                let created = new Date(this.state.ideaItem.CreatedDate);
                let abc = new Date(DISPLAYPROJECTTHEME);
                if (created.getTime() < abc.getTime()) {
                  //console.log("created date is lesser")
                  this.setState({ displayProjectTheme: true });
                } else {
                  this.setState({ displayProjectTheme: false });
                  //console.log("created date is greater ")
                }
              }
              REPLICABILITYOPTIONS.map((item) => {
                if (item.value === this.state.replicaIndex) {
                  const selectedOption = {
                    value: item.value,
                    label: item.label,
                  };
                  this.setState({ replicaIndex: selectedOption }, () => {
                    console.log(this.state.replicaIndex);
                  });
                }
              });
              //this.setCampaignName();
              //this.setServiceLineName();

              console.log("ideas ai at fetch function =>", this.state.ideasAI)

              if (this.state.ideasAI) {
                if (this.state.ideasAI.IsIdeaReplicable) {
                  this.setState({ isIdeaReplicable: "Yes" }, () => { })
                } else {
                  this.setState({ isIdeaReplicable: "No" }, () => { })
                }

                if (this.state.ideasAI.IsSolnFeasible) {
                  if (this.state.ideasAI.IsSolnFeasible === false || this.state.ideasAI.IsSolnFeasible === 0 || this.state.ideasAI.IsSolnFeasible === "0") {
                    this.setState({ IsSolnFeasibleValue: "No" }, () => { })
                  }
                  if (this.state.ideasAI.IsSolnFeasible === true || this.state.ideasAI.IsSolnFeasible === 1 || this.state.ideasAI.IsSolnFeasible === "1") {
                    this.setState({ IsSolnFeasibleValue: "Yes" }, () => { })
                  }
                }
              }
              if (
                this.state.ideaItem.PrevApprovalStatus ===
                "Documents Uploaded" &&
                this.state.ideaItem.ApprovalStatus === "Documents Uploaded"
              ) {
                this.setState(
                  { CommentEmpty: true, finalComment: "" },
                  () => { }
                );
              }
              if (
                this.state.IsVDType === VD_TO_CLIENT_PLUS_GENPACT
              ) {
                this.setState(
                  { showClientFields: true, showGOLFields: true },
                  () => { }
                );
              }
              if (this.state.IsVDType === NO_VD) {
                this.setState(
                  { showClientFields: false, showGOLFields: false },
                  () => { }
                );
              }
              if (this.state.IsVDType === VD_TO_CLIENT) {
                this.setState(
                  { showClientFields: true, showGOLFields: false },
                  () => { }
                );
              }
              if (this.state.IsVDType === VD_TO_GENPACT) {
                this.setState(
                  { showClientFields: false, showGOLFields: true },
                  () => { }
                );
              }
            }
          );
        }
      }

    } catch (error) {
      Toast.hide()
      Toast.fail("Error while fetching idea. Please try again!", 3000, () => { });
      console.log("error =>", error)
    };
  };

  fetchLDTandMBB = async () => {
    try {
      let entityType = "BB";
      let entityName = this.state.ideaItem.RegionManual;
      if (this.state.ideaItem.RegionManual === OTHER_REGIONS) {
        entityType = "BBOTHER";
        entityName = this.state.ideaItem.VerticalManual.replace(" - ", "-");
      }
      const param = {
        EntityType: entityType,
        EntityName: entityName,
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
        body: JSON.stringify(param),
      };

      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          Toast.hide();
          console.log(data)
          this.setState({
            // leadNameList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
            mbbList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
          });

          let filteredLDTLeadList = null;
          if (data.DataverseUserRoles) {
            filteredLDTLeadList = data.DataverseUserRoles.filter((item) => {
              const userRole = JSON.parse(item.pg_Role).pg_role;
              return (
                userRole === "LDT Lead" &&
                parseInt(this.state.ideaItem.OwnerOHR) !== parseInt(item.pg_ohr)
              );
            })
          }
          this.setState({
            leadNameList: filteredLDTLeadList,
          })
        }
      }
    } catch (error) {
      Toast.hide();
      console.log(JSON.stringify(error));
      Toast.fail("Error while getting LDT Lead metadata idea. Please try again!", 3000, () => { });
    }
  }

  validate = () => {
    this.FinalApproverCheck();
    let isValid = true;
    this.isExceedlimit = false;
    let styleStateObj = this.state.selectStyle;


    if (this.state.transSelectedOption === null || this.state.transSelectedOption === "" || this.state.transSelectedOption === undefined || this.state.transSelectedOption.length === 0 || !this.state.transSelectedOption) {
      isValid = false;
      styleStateObj.transSelectedOption = selectStyle(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      styleStateObj.transSelectedOption = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }

    if (this.state.transSelectedOption && this.state.transSelectedOption.label === "Digital") {
      if (this.state.digitalProjectTypeSelectedOptions === null || this.state.digitalProjectTypeSelectedOptions === undefined || !this.state.digitalProjectTypeSelectedOptions || this.state.digitalProjectTypeSelectedOptions.length === 0) {
        isValid = false;
        styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj
        })
      } else {
        styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj
        })
      }
    }

    if (this.state.aiClassificationListSelectedOption === null || this.state.aiClassificationListSelectedOption === undefined || this.state.aiClassificationListSelectedOption.length === 0 || !this.state.aiClassificationListSelectedOption) {
      isValid = false;
      styleStateObj.aiClassificationListSelectedOption = selectStyle(false)
      this.setState({
        selectStyle: styleStateObj
      })
    }
    else {
      styleStateObj.aiClassificationListSelectedOption = selectStyle(true)
      this.setState({
        selectStyle: styleStateObj
      })
    }
    if (this.state.methodologySelectedOptions === null || this.state.methodologySelectedOptions === undefined || !this.state.methodologySelectedOptions || this.state.methodologySelectedOptions.length === 0) {
      isValid = false;
      styleStateObj.methodologySelectedOptions = selectStyle(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    }
    else {
      styleStateObj.methodologySelectedOptions = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }


    if (this.displayCoderSection()) {
      if (this.state.CodersTable.length === 0 || !this.state.CodersTable || this.state.CodersTable === null || this.state.CodersTable === undefined) {
        Toast.fail("Atleast 1 coder OHR is required.", 3000)
        isValid = false;
      }
    }

    if (this.state.approvalSelectedOption === null || this.state.approvalSelectedOption === "" || this.state.approvalSelectedOption === undefined) {
      isValid = false;
      styleStateObj.approvalSelectedOption = selectStyle(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      styleStateObj.approvalSelectedOption = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }
    if (this.state.bbFieldValidationState.length === 0) {
      isValid = false;
      styleStateObj.showBBFieldsValidation = selectStyle(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      styleStateObj.showBBFieldsValidation = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }

    if (this.state.finalComment === "") {
      isValid = false;
      styleStateObj.finalComment = {
        ...textBoxValidation(false),
        border: "1px solid red",
      };
      this.setState({ selectStyle: styleStateObj });
    } else {
      if (this.state.finalComment && this.state.finalComment.length > 500) {
        Toast.fail(
          "Comment cannot be more than 500 characters, please change and resubmit.",
          3000
        );
        isValid = false;
        this.isExceedlimit = true;
        styleStateObj.finalComment = textBoxValidation(false);
        this.setState({ selectStyle: styleStateObj });
      } else {
        styleStateObj.finalComment = {
          ...textBoxValidation(true),
          border: "1px solid lightgrey",
        };
        this.setState({ selectStyle: styleStateObj });
      }
    }

    if (
      this.state.approvalSelectedOption &&
      this.state.approvalSelectedOption.label === "Approved" &&
      this.state.impactOptionSelected
    ) {
      if (!this.state.replicaIndex || this.state.replicaIndex.length === 0 || this.state.replicaIndex === null || this.state.replicaIndex === undefined) {
        isValid = false;
        styleStateObj.replicaIndex = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.replicaIndex = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj,
        });
      }

      if (this.state.filename1 === "" || this.state.filename1 === undefined || this.state.filename1 === null || !this.state.filename1) {
        isValid = false;
        Toast.fail("Please upload project presentation deck.", 3000, () => { });
      }


      if (this.state.impactOptionSelected.label !== NO_VD) {
        if ( this.state.businessImpactValueArray.length === 0 || this.state.businessImpactValueArray === null) {
          Toast.fail("Value Delivery cannot be empty, please fill and resubmit.",3000,() => { });
          isValid = false;
        }
        if (this.state.businessImpactValueArray && this.state.businessImpactValueArray !== null) {
          if (parseInt(this.state.finalImpactDollar) <= 0) {
            Toast.fail("Total Dollar Impact cannot be zero. Please check and resubmit.",3000,() => { });
            isValid = false;
          }
          if (this.state.finalImpactFTE > 0 && this.state.finalImpactDollar <= 0) {
            Toast.fail("Total Impact Dollar cannot be zero when FTE is non-zero. Please check and resubmit.",3000,() => { });
            isValid = false;
          }

          let showFTEImpactError = false;
          let showDollarImpactError = false;
          let FTEGreaterThanDollar = false;
          let myBIMasterList = this.state.businessImpactMasterList && this.state.businessImpactMasterList;

          this.state.businessImpactValueArray.filter((item) => {
            if (parseFloat(item.DollarImpact) === 0 || parseFloat(item.DollarImpact) === "" || !item.DollarImpact || item.DollarImpact === null) {
              showDollarImpactError = true;
            }
            for (const pg_item of myBIMasterList) {
              if (item.ImpactType === pg_item.pg_impacttype && item.MonetizableType === pg_item.pg_monetizabletype && item.BISubCategory === pg_item.pg_bisubcategory && pg_item.pg_isfteimpact === "Yes") {
                if (!item.FTEImpact || parseFloat(item.FTEImpact) === 0 || item.FTEImpact === null || item.FTEImpact === undefined || item.FTEImpact === "") {
                  showFTEImpactError = true;
                }
              }
            }
            if (item && item.isFTEPresent === true) {
              if (parseFloat(item.FTEImpact) > parseFloat(item.DollarImpact)) {
                FTEGreaterThanDollar = true;
              }
            }
          });

          if (showFTEImpactError === true) {
            isValid = false;
            Toast.fail("FTE Impact value cannot be zero", 3000, () => { });
          }
          if (showDollarImpactError === true) {
            isValid = false;
            Toast.fail("Dollar Impact value cannot be zero.", 3000, () => { });
          }
          if (FTEGreaterThanDollar === true) {
            isValid = false;
            Toast.fail("FTE impact value cannot be greater than dollar value.", 3000, () => { });
          }
        }
      }

      if ( this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT) {
        if (this.state.businessImpactValueArray.length > 0) {
          let impactGenpactTrue = this.state.businessImpactValueArray.some(
            (vendor) => vendor["ImpactType"] === IMPACT_TO_GENPACT
          );
          let impactClientTrue = this.state.businessImpactValueArray.some(
            (vendor) => vendor["ImpactType"] === IMPACT_TO_CLIENT
          );
          if (impactGenpactTrue === false) {
            isValid = false;
            Toast.fail("Please add both Impact types.", 3000, () => { });
          }
          if (impactClientTrue === false) {
            isValid = false;
            Toast.fail("Please add both Impact types.", 3000, () => { });
          }
        }
      }

      if (this.state.impactOptionSelected) {
        if (this.state.impactOptionSelected.label !== NO_VD) {
          if (this.state.monetizableProjectSelectedOption === null || this.state.monetizableProjectSelectedOption.length === 0 || this.state.monetizableProjectSelectedOption === undefined) {
            isValid = false;
            Toast.fail("Please select monetizatable project.", 5000, () => { });
          }
        }
      }

      if (this.state.monetizableProjectSelectedOption) {
        if (this.state.monetizableProjectSelectedOption.label === "Yes") {
          if (this.state.monetizationStatusSelectedOption === null || !this.state.monetizationStatusSelectedOption || this.state.monetizationStatusSelectedOption === undefined || this.state.monetizationStatusSelectedOption.length === 0) {
            isValid = false;
            Toast.fail("Since this project has been marked as Monetizable, monetizable status has to be selected.",5000,() => { });
          }

          if (this.state.businessImpactValueArray.filter((item) => item.IsMonetized === "Yes").length > 0) {
          }
          else {
            isValid = false;
            Toast.fail("Since this is a monetizable project, there needs to be at least one impact type as ‘Impact at Genpact’ selected and category selected as a ‘Increase in Revenue’ .", 5000, () => { });
          }


        }
      }
      if (this.state.monetizationStatusSelectedOption && this.state.monetizationStatusSelectedOption.label === "Approved by Client") {
        if (this.state.SowID === "" || this.state.SowID === null || this.state.SowID === undefined || this.state.SowID.length === 0 || !this.state.SowID) {
          isValid = false;
          Toast.fail("Please fill SOW ID/SFDC/OLI ID for monetization.", 3000,() => { });
        }
      }


      // this is for VD change
      if (this.state.impactOptionSelected) {
        if (this.state.showClientFields) {
          if (!this.state.clientName || this.state.clientName === null || this.state.clientName === undefined || this.state.clientName === "") {
            isValid = false;
            Toast.fail("Please fill client name.", 3000, () => { });
          }
          if (!this.state.clientRole || this.state.clientRole === "" || this.state.clientRole === null || this.state.clientRole === undefined) {
            isValid = false;
            Toast.fail("Please fill client role.", 3000, () => { });
          }
          if (!this.state.clientSignOffDate || this.state.clientSignOffDate === null || this.state.clientSignOffDate === undefined || this.state.clientSignOffDate === "") {
            isValid = false;
            Toast.fail("Please fill client sign-off date.", 3000, () => { });
          }
          if (!this.state.signOffFilename || this.state.signOffFilename === "" || this.state.signOffFilename===undefined || this.state.signOffFilename === null) {
            isValid = false;
            Toast.fail("Please Upload client sign-off Document.",3000,() => { } );
          }
        }
        if (this.state.impactOptionSelected.label === VD_TO_CLIENT || this.state.impactOptionSelected.label === VD_TO_GENPACT || this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT) {
          if (!this.state.golOhr || this.state.golOhr === undefined || this.state.golOhr === null || this.state.golOhr === "") {
            isValid = false;
            Toast.fail("Please fill GOL OHR.", 3000, () => { });
          }
          if (this.state.golOhr) {
            if (!this.state.golFullname) {
              isValid = false;
              Toast.fail("Please fill GOL OHR to fetch GOL Name.", 3000, () => { });
            }
          }
          
          if (this.state.isFpnaRequired) {
            if (!this.state.fpnaOhr) {
              isValid = false;
              Toast.fail("Please fill FP&A OHR.", 3000, () => { })
            }
            if (this.state.fpnaOhr) {
              if (!this.state.fpnaName) {
                isValid = false;
                Toast.fail("Please fill FP&A OHR to fetch FP&A name.", 3000, () => { })
              }
            }
          }

          if (this.state.golFpnaFileDetails !== null || !this.state.golFpnaFileDetails) {
            if (this.state.golFpnaFileDetails[0].label === "" && this.state.golFpnaFileDetails[1].label === "") {
              isValid = false;
              Toast.fail("Please upload the GOL / FP&A approval document.",3000, () => { });
            }
          }
        }
      }
    }
    
    // new productivity validation starts here
    if (this.state.approvalSelectedOption && this.state.approvalSelectedOption.label === "Approved") {
      let nonUploadedErrors = [];
      let lesserThanFTEErrors = [];

      let nonUploadedErrorsForFTEEq=[];
      let lessThanFTEErrorsForFTEEq=[]
      
      this.state.businessImpactValueArray && this.state.businessImpactValueArray.forEach((item, index) => {
        const { PValid, FTEImpact, OHRPastCount, ImpactType, MonetizableType, BISubCategory,OHRValidCount,OHRExceptionCount,OHRFutureCount,SrNo,OHRSumFTE } = item;
       
        if (PValid && PValid.length > 0) {
          const impactValue = parseFloat(FTEImpact);
          const truncatedImpactValue = FTEImpact ? Math.trunc(FTEImpact) : 0;
          const totalValidCount = (OHRValidCount + OHRExceptionCount + OHRFutureCount);
          const delta = impactValue - totalValidCount;
        
          // delta calcaulation for FTE 
          const FTEOHR = parseFloat(OHRSumFTE);
          const FTEDifference = FTEOHR - impactValue;

          if (!isNaN(impactValue) && impactValue >= 1) {
            // validation check for productivity older categories
            if (PValid === "No") {
              nonUploadedErrors.push(`Release OHR's missing for ${ImpactType} | ${MonetizableType} | ${BISubCategory}, please record productivity for this value category.`)
              isValid = false;
            }
            if (PValid === "Yes") {
              if (delta >= 1) {
                isValid = false;
                lesserThanFTEErrors.push(`Validated release OHR's must be greater than or equal to FTE value for ${ImpactType} | ${MonetizableType} | ${BISubCategory}.`)
              }
            }

            // validation check for FTE equivalent categories
            if(PValid === "FTE"){
              if (!FTEOHR || FTEOHR === 0 || FTEOHR === null || FTEOHR === undefined) {
                nonUploadedErrorsForFTEEq.push(`OHRs missing for ${ImpactType} | ${MonetizableType} | ${BISubCategory}, please record productivity for this value category.`)
                isValid = false;
              }
              
              if (FTEOHR && FTEOHR > 0) {
                console.log('fte difference =>',FTEDifference)
                if (FTEDifference >= -0.99 && FTEDifference <= 0.99) {
                  // this is valid case so do nothing here
                }else{
                  isValid = false;
                  lessThanFTEErrorsForFTEEq.push(`The total realized value of uploaded OHRs does not match the reported FTE impact for the category “${ImpactType} | ${MonetizableType} | ${BISubCategory}“ (±1 tolerance).`);
                }
              }
            }
          }
        }
      });

      if (nonUploadedErrors.length > 0) {
        if (nonUploadedErrors.length > 2) {
          isValid = false;
          Toast.fail("Release OHR's missing, please update for Impact at Client | Productivity | RGFTE reduction, Impact at Genpact | Productivity | Reduction to Over Deployment Bench and RGFTE reduction categories.", 10000, () => { })
        } else {
          isValid = false;
          nonUploadedErrors.forEach(err =>
            Toast.fail(err, 8000, () => { })
          )
        }
      }
      if (lesserThanFTEErrors.length > 0) {
        if (lesserThanFTEErrors.length > 2) {
          isValid = false;
          Toast.fail(`Validated release OHR's must be greater than or equal to FTE value for Impact at Client | Productivity | RGFTE reduction, Impact at Genpact | Productivity | Reduction to Over Deployment Bench and RGFTE reduction categories.`, 10000, () => { })
        } else {
          isValid = false;
          lesserThanFTEErrors.forEach(err =>
            Toast.fail(err, 8000, () => { })
          )
        }
      }



      // FTE equivalent catgories
      if(nonUploadedErrorsForFTEEq.length > 0){
        if (nonUploadedErrorsForFTEEq.length > 2) {
          isValid = false;
          Toast.fail("OHRs missing, please update for Impact at Client | Productivity | FTE Equivalent – Absorbed More Work with Same HC / Cost, Impact at Genpact | Productivity | FTE Equivalent – Improvement in Transaction-Based Billing and FTE Equivalent – Increase in Billable Hours categories.", 10000, () => { })
        } else {
          isValid = false;
          nonUploadedErrorsForFTEEq.forEach(err =>
            Toast.fail(err, 8000, () => { })
          )
        }
      }
      if(lessThanFTEErrorsForFTEEq.length>0){
        if (lessThanFTEErrorsForFTEEq.length > 2) {
          isValid = false;
          Toast.fail(`The total realized value of uploaded OHRs does not match the reported FTE impact for the category “Impact at Client | Productivity | FTE Equivalent – Absorbed More Work with Same HC / Cost, Impact at Genpact | Productivity | FTE Equivalent – Improvement in Transaction-Based Billing and FTE Equivalent – Increase in Billable Hours“ (±1 tolerance).`, 10000, () => { })
        } else {
          isValid = false;
          lessThanFTEErrorsForFTEEq.forEach(err =>
            Toast.fail(err, 8000, () => { })
          )
        }
      }
    }

    // new productivity validation ends here

    return isValid;
  };


  updateIdea = (event) => {
    let param = {
      ProjectPPTDeck: this.state.base64File1,
      ProjectPPTFilename: this.state.filename1
        ? this.state.filename1
        : this.state.ideaItem.ProjectPPTFileName,
      ProjectPPTType: this.state.fileType1
        ? this.state.fileType1
        : this.state.ideaItem.ProjectPPTType,

      CustomerLeadSignOff: this.state.signOffContent,
      CustomerSignoffFilename: this.state.signOffFilename
        ? this.state.signOffFilename
        : this.state.ideaItem.CustomerSignoffFileName,
      CustomerSignoffType: this.state.signOffFileType
        ? this.state.signOffFileType
        : this.state.ideaItem.CustomerSignoffType,




      // golApproval:this.state.base64File3,
      // golApprovalFileName:this.state.filename3 ? this.state.filename3 : this.state.ideaItem.GOLFileName,
      // golApprovalType:this.state.fileType3 ? this.state.fileType3 : this.state.ideaItem.GOLFileType,
      golApproval: this.state.base64File3,
      golApprovalFileName: this.state.filename3,
      golApprovalType: this.state.fileType3,

      // fpnaApproval:this.state.base64File4,
      // fpnaApprovalFileName:this.state.filename4 ? this.state.filename4 : this.state.ideaItem.FPnAFileName,
      // fpnaApprovalType:this.state.fileType4 ? this.state.fileType4 : this.state.ideaItem.FPnAFileType,
      fpnaApproval: this.state.base64File4,
      fpnaApprovalFileName: this.state.filename4,
      fpnaApprovalType: this.state.fileType4,
      IdeaId: this.props.location.state,
      ModifiedByOHR: this.sessionData.profile.oHRId,
      Role: "Mentor",
      ClientName: this.state.clientName,
      ClientRole: this.state.clientRole,
      ClientSignOffDate: this.state.clientSignOffDate,
      GolOhr: this.state.golFullname ? this.state.golOhr : "",
      FpnaName: this.state.fpnaName,
      GolFullname: this.state.golFullname,
      FpnaOhr: this.state.fpnaName ? this.state.fpnaOhr : "",
      
    };
    console.log(param);
  
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + this.accessToken,
      },
      body: JSON.stringify(param),
    };

    fetch(`${UPDATE_IDEA_URL}documentsonly=''`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
      });
  };



  showProductivityPopup = () => {
    return new Promise((resolve) => {
      this.setState({
        backFillPopup: true,
        popupResolver: resolve // Save the resolve function to state
      });
    });
  };

  handleProductivityPopupAction = (isApproved) => {
    // 1. Close the popup
    this.setState({ backFillPopup: false });

    // 2. Trigger the Promise resolution if it exists
    if (this.state.popupResolver) {
      this.state.popupResolver(isApproved); // Sends true or false back to submitIdea
    }
  };

  showFTEProductivityPopup = () => {
    return new Promise((resolve) => {
      this.setState({
        FTEPopup: true,
        popupResolverFTE: resolve // Save the resolve function to state
      });
    });
  };

  handleFTEProductivityPopupAction = (isApproved) => {
    this.setState({ FTEPopup: false });

    // 2. Trigger the Promise resolution if it exists
    if (this.state.popupResolverFTE) {
      this.state.popupResolverFTE(isApproved); // Sends true or false back to submitIdea
    }
  };

  submitIdea = async() => {
    if (this.validate()) {
      let showPopup = false;
      let FTEPopup= false;

      if (this.state.approvalSelectedOption?.label === "Approved") {
        showPopup = this.state.businessImpactValueArray?.some((item) => {
          const { PValid, FTEImpact } = item;
          const impactValue = parseFloat(FTEImpact);

          return (
            PValid &&
            PValid.length > 0 &&
            !isNaN(impactValue) &&
            impactValue < 1 &&
            PValid === "No"
          );
        });

        if (showPopup) {
           const userApproved = await this.showProductivityPopup();
            // 2. If the user clicked "Pause Approval", stop execution here
            if (!userApproved) {
              return; 
            }
        }

        FTEPopup = this.state.businessImpactValueArray?.some((item) => {
          const { PValid, FTEImpact, OHRSumFTE, OHRPastCount } = item;
          const impactValue = parseFloat(FTEImpact);
          const FTEOHRCount = parseFloat(OHRSumFTE);
          

          return (
            PValid &&
            PValid.length > 0 &&
            !isNaN(impactValue) &&
            impactValue < 1 &&
            PValid === "FTE" && !FTEOHRCount
          );
        });

        if (FTEPopup) {
          const userApproved = await this.showFTEProductivityPopup();
          // 2. If the user clicked "Pause Approval", stop execution here
          if (!userApproved) {
            return;
          }

        }
      }

      if (window.confirm("Are you sure you want to submit the lean project?")) {
        Toast.loading("Updating lean project...", () => { });
        this.state.businessImpactValueArray =
          this.state.businessImpactValueArray && this.state.businessImpactValueArray
            .map((item) => ({
              ...item,
              pg_srno: item.SrNo,
              dollarValue: item.DollarImpact,
              fteValue: item.FTEImpact,
            }))
            .map((item) => {
              return item;
            });

        let filteredBIData = this.state.businessImpactValueArray && this.state.businessImpactValueArray.filter(
          function (e) {
            return (
              e !== null &&
              e !== undefined &&
              parseFloat(e.DollarImpact) > 0 &&
              ((e.isFTEPresent && parseFloat(e.FTEImpact) > 0) ||
                !e.isFTEPresent)
            );
          }
        );


        let checkifBiContainsProductivityLineItems = false;
        checkifBiContainsProductivityLineItems = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some(item => item.PValid && item.PValid.length > 0);

      
        let CodersTableWithSOrd = this.state.CodersTable && this.state.CodersTable.map((item, index) => ({ ...item, SOrd: index }));

        let MethodolodyToolsSelectedLabels = '';
        if (this.state.methodologySelectedOptions) {
          MethodolodyToolsSelectedLabels = this.state.methodologySelectedOptions.map(option => `${option.label}`).join('|');
        }

        
        let param = {};
        param = {
          OnInitPageTime:this.state.onInitPageTime,
          IdeaName: this.state.ideaItem.IdeaName,
          CertificationLevelId: this.state.ideaItem.CertificationLevelId,
          CertificationWorkTypeName: this.state.ideaItem.CertificationWorkTypeName,
          CertificationLevelName: this.state.ideaItem.CertificationLevelName,

          IsDigital: this.state.ideaItem.IsDigital,
          IsReplicationVerified: this.state.ideaItem.IsReplicationVerified,
          LDTId: this.state.ldtSelectedOption && this.state.ldtSelectedOption.value,
          LDTName: this.state.ldtSelectedOption && this.state.ldtSelectedOption.label,
          MBBOHR: this.state.mbbSelectedOption && this.state.mbbSelectedOption.value,
          MBBName: this.state.mbbSelectedOption && this.state.mbbSelectedOption.label,

          OwnerEmail: this.state.ideaItem.CreatorEmail ? this.state.ideaItem.CreatorEmail : this.state.ideaItem.OwnerEmail,
          

          Problem: this.state.ideaItem.Problem,
          Solution: this.state.ideaItem.Solution,
          ServiceLineId: this.state.ideaItem.ServiceLineId,
          ServiceLineName: this.state.ideaItem.ServiceLineName,
          SubServiceLine: this.state.ideaItem.SubServiceLine,
          NewOrReplicatedIdea: this.state.ideaItem.NewOrReplicatedIdea,
          ReplicationProjectId: this.state.ideaItem.ReplicationProjectId,

          UpdaterOHR: this.sessionData.profile.oHRId,
          UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
          UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
          WorkflowStatus: this.state.approvalSelectedOption.label,
          ApprovalStatus: this.state.approvalStatusState,

          FinalComments: this.state.finalComment,
          IdeaId: this.props.location.state,
          IsBestInClass: this.state.showFinalAdditionalDetails ? this.state.bestClass : null,
       
          
          FinalImpactDollar: this.state.finalImpactDollar ? this.state.finalImpactDollar : this.state.ideaItem.FinalImpactDollar,
          FinalImpactFTE: this.state.finalImpactFTE
            ? this.state.finalImpactFTE
            : this.state.ideaItem.FinalImpactFTE,

       
          

          FinalOtherTools: this.state.showFinalAdditionalDetails
            ? this.state.otherTools
            : null,
          IsZeroImpactProject: this.state.impactOptionSelected?.label === NO_VD ? 1 : 0,

          DataBridgeTheme: this.state.ideaItem.DataBridgeTheme,
          BusinessImpactData: filteredBIData,
          CampaignName: this.state.ideaItem.CampaignName,
          Comment: this.state.ideaItem.Comment,

          Role: "Mentor",

          CompletedDate: new Date().toLocaleString(),
          FpnaApprovalAttachedSelectedOption: this.state.showBBFieldsValue ? "Yes" : "No",

          IsFPnAApprovalAttached: this.state.ideaItem.IsFPnAApprovalAttached,
          ImpactTyepChanged: this.state.ideaItem.IsVDImpactTagged,
          DeliveryCategorizedSelect: this.state.ideaItem.IsVDCategorized,
          DeliveryComputedCorrectlySelected: this.state.ideaItem.IsVDComputed,
          SignOffDeliverySelected: this.state.ideaItem.IsVDClientSignOff,
          IsVDReviewed: this.state.ideaItem.IsVDReviewed,

          QcOHR: this.state.ideaItem.QCOHR ? this.state.ideaItem.QCOHR : "",
          QcEmail: this.state.ideaItem.QCOHR ? this.state.ideaItem.QCOHR + "@genpact.com": "",
          QcUpdaterName: this.state.ideaItem.QCName? this.state.ideaItem.QCName: "",

          FPnAOHR: this.state.fpnaOhr
            ? this.state.fpnaOhr
            : this.state.ideaItem.FPnAOHR,
          FPnAName: this.state.fpnaName
            ? this.state.fpnaName
            : this.state.ideaItem.FPnAName,

          FPnAOHRMonetization: this.state.FPnAOHRMonetizationInput
            ? this.state.FPnAOHRMonetizationInput
            : this.state.FPnAOHRMonetization,
          FPnANameMonetization: this.state.FPnANameMonetizationInput
            ? this.state.FPnANameMonetizationInput
            : this.state.FPnANameMonetization,
          SowID: this.state.SowID
            ? this.state.SowID
            : this.state.ideaItem.SowID
              ? this.state.ideaItem.SowID
              : "",
          IsVDMonetizable: this.state.monetizableProjectSelectedOption
            ? this.state.monetizableProjectSelectedOption.label
            : this.state.ideaItem.IsVDMonetizable
              ? this.state.ideaItem.IsVDMonetizable
              : "",
          MonetizationStatus: this.state.monetizationStatusSelectedOption
            ? this.state.monetizationStatusSelectedOption.label
            : this.state.ideaItem.MonetizationStatus
              ? this.state.ideaItem.MonetizationStatus
              : "",
          IsMbbMonetizable: this.state.ideaItem.IsMbbMonetizable
            ? this.state.ideaItem.IsMbbMonetizable
            : "",
          VDType: this.state.impactOptionSelected
            ? this.state.impactOptionSelected.label
            : this.state.ideaItem.VDType,
          ReplicabilityIndex: this.state.replicaIndex
            ? this.state.replicaIndex.value
            : "",
          updaterAction: this.state.approvalSelectedOption
            ? this.state.approvalSelectedOption.label === COMPLETE_STATUS
              ? "Approved"
              : this.state.approvalSelectedOption.label
            : "",

          GOLNameMonetization: this.state.golMonetizationName
            ? this.state.golMonetizationName
            : this.state.ideaItem.GOLName,
          GOLOHRMonetization: this.state.golMonetizationOhr
            ? this.state.golMonetizationName
            : this.state.ideaItem.GOLOHR,



          LeanID: this.state.ideaItem.LeanID ? this.state.ideaItem.LeanID : "",
          checkifBiContainsProductivityLineItems: checkifBiContainsProductivityLineItems,

          TLID: this.state.transSelectedOption.value,
          TransformationLeverName: this.state.transSelectedOption.label,

          DigitalProjectType: this.state.digitalProjectTypeSelectedOptions && this.state.digitalProjectTypeSelectedOptions.label,
          DPTypeID: this.state.digitalProjectTypeSelectedOptions && this.state.digitalProjectTypeSelectedOptions.value,
          
          AIClassification: this.state.aiClassificationListSelectedOption?.label,

          MethodologyName: MethodolodyToolsSelectedLabels,
          OtherTools: this.state.OtherTools ? this.state.OtherTools : "",

          codersTableUpdated: this.checkifCoderTableUpdated(this.state.olderCoderTable, this.state.CodersTable),
          CodersField: CodersTableWithSOrd ? CodersTableWithSOrd : [],

          

        };

        console.log(param);
        
        const requestOptions = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.accessToken,
          },
          body: JSON.stringify(param),
        };
        fetch(`${REVIEW_IDEA_URL}`, requestOptions)
        // Code change by TR
        .then((response) => {
          return response.json().then((data) => {
            if (response.status === 409) {
              Toast.fail( "Idea has been updated by owner", 5000);
        
              setTimeout(() => {
              this.props.history.push("/review-page");
              }, 5000);
        
              return null; 
            }
        
            return data;
          });
        })
        .then((data) => {
          if (!data){
            return;
          } 
          this.updateIdea();
          
          // Code change by TR
            Toast.hide();
            Toast.success("Updated successfully.", 3000, () => {
              this.props.history.push("/review-page?page=leanapproval");
              console.log(JSON.stringify(data));
            });
          });
      }
    } else {
      if (!this.isExceedlimit) {
        Toast.fail(
          "Required fields are missing or have invalid values. Please correct and try again.",
          3000,
          () => { }
        );
      }
    }
    return false;
  };

  

  renderStatusOptions = () => {
    let options = [];
    if (this.state.bbFieldValidationState && this.state.bbFieldValidationState.label === "No") {
      this.state.finalApproveOptionsValue.slice(-2).map((item) => {
        options.push({
          value: item.WorkflowStatusId,
          label: item.WorkflowStatusName,
        });
        return options;
      });
    }
    if (this.state.bbFieldValidationState && this.state.bbFieldValidationState.label === "Yes") {
      this.state.finalApproveOptionsValue.map((item) => {
        options.push({
          value: item.WorkflowStatusId,
          label: item.WorkflowStatusName,
        });
        return options;
      });
    }
    return options;
  };

  handleApprovalStatus = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.approvalSelectedOption = selectStyle(true);
    this.setState({ approvalSelectedOption: e, selectStyle: styleStateObj, finalComment: "" }, () => { });
  };

  
  renderTransLeversOptions = () => {
    let options = [];
    let result = [];
    let filteredData = this.state.campaignUnionQuery && this.state.campaignUnionQuery.filter((item)=>{return item.TransformationLever !== "Data"})
    filteredData && filteredData.map((item) => {
      if (this.state.ideaItem.CampaignID === item.CampaignID) {
        options.push({ value: item.TLID, label: item.TransformationLever, SOrd: item.TLOrd });
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);
    result.sort((a, b) => a.SOrd - b.SOrd);
    return result
    return options;
  };



  handleTransLeversChange = (e) => {
    console.log("transSelectedOption =>",e)
    let styleStateObj = this.state.selectStyle;
    styleStateObj.transSelectedOption = selectStyle(true);
    this.setState({
      transSelectedOption: e,
      selectStyle: styleStateObj,
      digitalProjectTypeSelectedOptions: null,
      digitalProjectEnabled: false,
      aiClassificationListSelectedOption: null,
      methodologySelectedOptions: null,
      OtherTools: "",
      CodersTable: [],
    });

    if (e.label === "Digital") {
      this.renderDigitalProjectTypeOptions();
      this.setState({
        digitalProjectEnabled: true,
      });
    } else {
      this.setState({
        digitalProjectEnabled: false,
      });
    }

  };


  renderDigitalProjectTypeOptions = () => {
    // let options = [];
    // this.state.digitalProjectTypeList && this.state.digitalProjectTypeList.map((item) => {
    //   if (item.DPType !== "RPA") {
    //     if (item.TLID === this.state.transSelectedOption?.value) {
    //       options.push({
    //         value: item.RecID,
    //         label: item.DPType,
    //       })
    //     }
    //   }
    //   return options;
    // });
    // return options;


    let options = [];
    let result = [];

    this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
      if (item.DPType) {
        if (this.state.ideaItem.CampaignID === item.CampaignID) {
          if (this.state.transSelectedOption?.value === item.TLID) {
            if (item.DPType !== "RPA") {
              options.push({ value: item.DPTypeID, label: item.DPType,SOrd:item.DPOrder });
            }
          }
        }
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);

    console.log('result =>',result)

    result.sort((a,b)=> a.SOrd - b.SOrd)
    return result


  };


  handleDigitalProjectTypeChange = (e) => {
    console.log("digital project selected option =>",e)
    let styleStateObj = this.state.selectStyle;
    styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(true);
    this.setState({
      CodersTable: [],
      selectStyle: styleStateObj,
      digitalProjectTypeSelectedOptions: {
        value: e.value,
        label: e.label,
      },
      methodologySelectedOptions: null,
      OtherTools:"",
      aiClassificationListSelectedOption: null
    });
  };


  renderAIClassificationList = () => {
    let options = [];
    if (this.state.transSelectedOption) {
      if (this.state.digitalProjectTypeSelectedOptions) {
        this.state.aiClassificationList && this.state.aiClassificationList.map((item) => {
          if (item.TransformationLever === "Digital" && this.state.transSelectedOption?.label === "Digital") {
            if (item.DigitalProjectType === this.state.digitalProjectTypeSelectedOptions.label) {
              options.push({
                value: item.RecID,
                label: item.AIClassification
              })
            }
          }
        })
      }
      else {
        this.state.aiClassificationList && this.state.aiClassificationList.map((item) => {
          if (item.RecStatus === true && item.DigitalProjectType === null && item.TransformationLever === this.state.transSelectedOption.label) {
            if(this.state.ideaItem.campaignName === "Gen AI"){
              if(item.AIClassification === "Gen AI"){
                options.push({
                  value: item.RecID,
                  label: item.AIClassification
                })
              }
            }else{
              options.push({
                value: item.RecID,
                label: item.AIClassification
              })
            }
          }
        })
      }
    }
    // console.log("AI classification options =>",options && options.length)
    return options;
  }

  handleAIClassificationChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.aiClassificationListSelectedOption = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      aiClassificationListSelectedOption: {
        value: e.value,
        label: e.label,
      },
      methodologySelectedOptions: null,
      OtherTools:"",
    }, () => {
    }
    );
  }

  renderMethodologyOptions = () => {
    let options = [];
    this.state.methodologyList && this.state.methodologyList.map((item, ind) => {
      if (this.state.transSelectedOption && this.state.transSelectedOption.label === item.TransformationLever && item.RecStatus === true && this.state.aiClassificationListSelectedOption?.label === item.AIClassification) {
        if (this.state.digitalProjectTypeSelectedOptions) {
          if (this.state.digitalProjectTypeSelectedOptions.label === item.DigitalProjectType) {
            options.push({
              value: item.RecID,
              label: item.Methodology,
              sortOrder: item.SOrd || 0
            })
          }
        }
        else {
          options.push({
            value: item.RecID,
            label: item.Methodology,
            sortOrder: item.SOrd || 0
          })
        }
      }
    })
    options.sort((a, b) => a.sortOrder - b.sortOrder);
    // console.log("options length =>", options.length)
    return options.map(({ value, label }) => ({ value, label }));;
  };

  handleMethodologyChange = (e) => {
    if (e.length <= 10) {
      let styleStateObj = this.state.selectStyle;
      styleStateObj.methodologySelectedOptions = selectStyle(true);
      this.setState({ methodologySelectedOptions: e, selectStyle: styleStateObj,OtherTools:"" }, () => { });
    } else {
      window.alert("You can add upto 10 tools/methodologies options only.")
      return false;
    }
  };



  handleOtherToolsChange = (e) => {
    let nonWhiteSpace = e.replace(/^\s+|\s+$/gm, '');
    let styleStateObj = this.state.selectStyle;
    styleStateObj.OtherTools = textBoxValidation(true);
    if (nonWhiteSpace.length <= 300) {
      this.setState({ OtherTools: e, selectStyle: styleStateObj, }, () => { })
    } else {
      const trimmedValue = nonWhiteSpace.slice(0, 300);
      this.setState({ OtherTools: trimmedValue }, () => { });
    }
  }

  handleFinalCommentChange = (event) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.finalComment = {
      ...textBoxValidation(true),
      border: "1px solid lightgray",
    };
    this.setState({ finalComment: event.target.value, selectStyle: styleStateObj }, () => { });


  };
  handleTranscriptFinalApprovalComment = (e) => {
    setTimeout(() => {
      if (e !== null && e !== undefined) {
        let finalComment = e;
        this.setState({
          finalComment: finalComment,
        });
      }
    }, 1000);
  };
  newBusinessImpactSummary = () => {
    if (this.state.businessImpactValueArray) {

      let myArray = [...this.state.businessImpactValueArray];
      const groupedData = myArray.reduce((accumulator, currentValue) => {
        const impactType = currentValue.impactType;
        const monetizableType = currentValue.monetizableType;
        const fteValue = parseFloat(currentValue.fteValue) || 0.0;
        const dollarValue = parseFloat(currentValue.dollarValue) || 0.0;

        const existingRow = accumulator.find(
          (row) =>
            row.impactType === impactType &&
            row.monetizableType === monetizableType
        );
        if (existingRow) {
          existingRow.fteValue += fteValue;
          existingRow.dollarValue += dollarValue;
        } else {
          accumulator.push({
            impactType,
            monetizableType,
            fteValue,
            dollarValue,
          });
        }
        return accumulator;
      }, []);
      this.setState({ summaryArray: groupedData }, () => { });
      this.setState(
        { businessImpactValueArray: this.state.businessImpactValueArray },
        () => {
          //console.log('bi at the end of function =>',this.state.businessImpactValueArray)

         }
      );

      let isFpnaRequired = false;
      this.state.businessImpactValueArray && this.state.businessImpactValueArray.map((item) => {
        if (item.ImpactType === IMPACT_TO_GENPACT) {
          if (item.MonetizableType === "Increase in Revenue" || item.MonetizableType === "Reduction in Cost" || item.MonetizableType === "Productivity") {
            isFpnaRequired = true;
          }
        }
        if (item.MonetizableType && item.MonetizableType === "Productivity") {
          isFpnaRequired = true;
        }
      })
      this.setState({ isFpnaRequired: isFpnaRequired }, () => { })


      if (this.state.impactOptionSelected && (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT || this.state.impactOptionSelected.label === VD_TO_CLIENT)) {
        let clientNonProductivity = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some((e) => e.ImpactType === IMPACT_TO_CLIENT && ["Increase in Revenue", "Reduction in Cost", "Cash Impact", "Others"].includes(e.MonetizableType));
        if (clientNonProductivity) {
          this.setState({ showClientFields: true }, () => { })
        } else {
          this.setState({ showClientFields: false }, () => { })
          let genpactNonProducitivity = this.state.businessImpactValueArray.some((e) => e.ImpactType === IMPACT_TO_GENPACT && ["Increase in Revenue", "Reduction in Cost", "Cash Impact", "Others"].includes(e.MonetizableType));
          if (genpactNonProducitivity) {

          } else {
            this.setState({ showClientFields: false }, () => { })
          }
        }
      }

    }
  }

  FinalApproverCheck() {
    if (this.state.ideaItem.QCOHR && this.state.ideaItem.QCName) {
      let Approver = AWAITING_PROJECT_APPROVAL;
      if (this.state.finalImpactDollar >= 50000) {
        Approver = AWAITING_MASTER_BLACKBELT_APPROVAL;
      }
      if (this.state.monetizableProjectSelectedOption !== null) {
        if (this.state.monetizableProjectSelectedOption.label === "Yes") {
          Approver = AWAITING_MASTER_BLACKBELT_APPROVAL;
        }
      }
      if (this.state.ideaItem.ApprovalStatus === "Rework - QC") {
        Approver = AWAITING_PROJECT_APPROVAL;
      }
      if (this.state.approvalSelectedOption !== null) {
        if (this.state.approvalSelectedOption.label === "Send Back") {
          Approver = "Pending Documents";
        } else if (this.state.approvalSelectedOption.label === "Rejected") {
          Approver = "Rejected";
        }
      }
      this.state.approvalStatusState = Approver;
      this.setState({ approvalStatusState: Approver }, () => { }
      );
    }
    else {
      let Approver = COMPLETE_STATUS;
      if (this.state.biThreshold !== 0 && this.state.finalImpactDollar !== 0 && this.state.impactOptionSelected && this.state.impactOptionSelected.label !== NO_VD) {
        if (this.state.finalImpactDollar >= this.state.biThreshold) {
          if (this.state.vrconditiontype === "AND") {
            if ((this.state.vrVerticalMapping.includes(this.state.ideaItem.VerticalManual) || this.state.vrVerticalMapping === "ALL") && (this.state.vrRegionMapping.includes(this.state.ideaItem.RegionManual) || this.state.vrRegionMapping === "ALL") && this.state.IsSampleCheck) {
              Approver = AWAITING_QAULITY_CHECK_REVIEW;
            }
          } else {
            if (this.state.vrVerticalMapping.includes(this.state.ideaItem.VerticalManual) || this.state.vrVerticalMapping === "ALL" || ((this.state.vrRegionMapping.includes(this.state.ideaItem.RegionManual) || this.state.vrRegionMapping === "ALL") && this.state.IsSampleCheck)) {
              Approver = AWAITING_QAULITY_CHECK_REVIEW;
            }
          }
        }
      }

      if (this.state.finalImpactDollar >= 50000) {
        Approver = AWAITING_MASTER_BLACKBELT_APPROVAL;
      }
      if (this.state.monetizableProjectSelectedOption) {
        if (this.state.monetizableProjectSelectedOption.label === "Yes") {
          Approver = AWAITING_MASTER_BLACKBELT_APPROVAL;
        }
      }
      if (this.state.ideaItem.ApprovalStatus === "Rework - QC") {
        Approver = AWAITING_PROJECT_APPROVAL;
      }
      if (this.state.approvalSelectedOption !== null) {
        if (this.state.approvalSelectedOption.label === "Send Back") {
          Approver = "Pending Documents";
        } else if (this.state.approvalSelectedOption.label === "Rejected") {
          Approver = "Rejected";
        }
      }
      this.state.approvalStatusState = Approver;
      this.setState({ approvalStatusState: Approver }, () => { }
      );
    }
  }

  handleClassChange = (event) => {
    this.setState((previousState, currentProps) => {
      return {
        bestClass: !previousState.bestClass,
      };
    });
  };

  formatDateString(dateparam) {
    return dateparam.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  cancelEvent = () => {
    this.props.history.push("/review-page?page=leanapproval");
  };



  replicaIndexChangeHandler = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.replicaIndex = selectStyle(true);
    this.setState(
      {
        replicaIndex: e,
        selectStyle: styleStateObj,
      },
      () => {

      }
    );
  };

  formatDateStringWithTime(dateparam) {
    return dateparam.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  toggleTranscriptFunction = (id) => {
    this.setState({ speechModal: !this.state.speechModal, modalIndex: id });
    if (id === 7) {
      if (this.state.finalComment) {
        this.setState({ previousTextForSpeech: this.state.finalComment }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      } else {
        this.setState({ previousTextForSpeech: "" }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      }
    }else if(id===3){
      if (this.state.cancelComment) {
        this.setState({ previousTextForSpeech: this.state.cancelComment }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      } else {
        this.setState({ previousTextForSpeech: "" }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      }
    }
  };

  closeModalFunction = () => {
    this.setState({ speechModal: false });
  };


  showBBFields = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.showBBFieldsValidation = selectStyle(true);
    this.setState({ selectStyle: styleStateObj, approvalSelectedOption: "", finalComment: "", bbFieldValidationState: e });

    if (e !== null && e !== undefined && e.label === "No") {
      this.setState({
        bestClass: false,
        otherTools: null,
      });
    }
  };

  pull_data = (businessImpactValueArray) => {
    console.log('business impact at pull_data function',businessImpactValueArray)
    this.setState({ businessImpactValueArray: businessImpactValueArray }, () => {
        this.newBusinessImpactSummary();
      }
    );
    let dollarTotal = 0.0;
    let fteValue = 0.0;
    if (businessImpactValueArray) {
      if (businessImpactValueArray.length > 0) {
        businessImpactValueArray.map((item) => {
          if (item && item.DollarImpact) {
            dollarTotal += parseFloat(item.DollarImpact);
          }
          if (item && item.dollarValue) {
            dollarTotal += parseFloat(item.dollarValue);
          }
          if (item && item.FTEImpact) {
            fteValue += parseFloat(item.FTEImpact);
          }
          if (item && item.fteValue) {
            fteValue += parseFloat(item.fteValue);
          }
        });
      }
    }
    this.setState({ finalImpactDollar: dollarTotal, finalImpactFTE: fteValue }, () => { });
    if (this.state.impactOptionSelected && this.state.impactOptionSelected.label === NO_VD) {
      this.setState({ finalImpactDollar: 0, finalImpactFTE: 0 }, () => { });
    }

  };
  remove_bi_data_after_delete = (filteredIdeaArray) => {
    if (filteredIdeaArray) {
      this.setState({ businessImpactValueArray: filteredIdeaArray }, () => {
        this.newBusinessImpactSummary();
        let dollarTotal = 0.0;
        let fteValue = 0.0;
        this.state.businessImpactValueArray.map((item) => {
          if (item && item.DollarImpact) {
            dollarTotal += parseFloat(item.DollarImpact);
          }
          if (item && item.dollarValue) {
            dollarTotal += parseFloat(item.dollarValue);
          }
          if (item && item.FTEImpact) {
            fteValue += parseFloat(item.FTEImpact);
          }
          if (item && item.fteValue) {
            fteValue += parseFloat(item.fteValue);
          }
        });
        this.setState({ finalImpactDollar: dollarTotal }, () => {
          //console.log("inside call back function $ total",this.state.finalImpactDollar)
        });
        this.setState({ finalImpactFTE: fteValue }, () => {
          //console.log("inside call back function fte value",this.state.finalImpactFTE)
        });
      });
    }
  };

  pull_file_data = ({
    fileName,
    fileType,
    fileContent,
    showClientApprovalFields,
    SowID,
    FPnAOHRMonetization,
    FPnANameMonetization,
  }) => {
    if (fileName) {
      this.setState({ FPnAFileNameMonetization: fileName }, () => { });
    }
    if (fileType) {
      this.setState({ FPnAFileTypeMonetization: fileType }, () => { });
    }
    if (fileContent) {
      this.setState({ FPnAFileMonetization: fileContent }, () => { });
    }

    this.setState(
      { showClientApprovalFields: showClientApprovalFields },
      () => { }
    );
    this.setState(
      {
        SowID: SowID,
        FPnAOHRMonetization: FPnAOHRMonetization,
        FPnANameMonetization: FPnANameMonetization,
      },
      () => { }
    );
  };
  pull_monetizedTotal = ({ fteValue, dollarValue }) => {
    if (fteValue) {
      this.setState({ totalMonetizedDollar: fteValue }, () => { });
    }
    if (dollarValue) {
      this.setState({ totalMonetizedFTE: dollarValue }, () => { });
    }
  };
  pull_monetizableProject = (e) => {
    console.log("monetizable project at fetch function=>",e)
    this.setState({ monetizableProjectSelectedOption: e }, () => {
      //console.log("monetizable Project Selected Option =>",this.state.monetizableProjectSelectedOption)
    });
  };
  pull_monetizableStatus = (e) => {
    //console.log("monetizable status at props=>",e)
    this.setState({ monetizationStatusSelectedOption: e }, () => {
      //console.log("monetizable Project status Selected Option =>",this.state.monetizationStatusSelectedOption)
    });
  };
  pull_monetization_fpna_name = (localFpnaName) => {
    this.setState({ FPnANameMonetization: localFpnaName }, () => { });
  };
  pull_monetization_fpna_ohr = (localFpnaohr) => {
    this.setState({ FPnAOHRMonetization: localFpnaohr }, () => { });
  };
  handleVDTypeChange = (e) => {
    this.setState({ impactOptionSelected: e, impactChanged: true }, () => {
        if (this.state.impactOptionSelected.label === NO_VD) {
          this.setState(
            {
              showClientFields: false,
              showGOLFields: false,
              finalImpactDollar: 0,
              monetizableProjectSelectedOption: null,
              businessImpactValueArray: [],
              businessImpactValueArray: null
            },
            () => {

            }
          );
        }
        if (
          this.state.impactOptionSelected.label === VD_TO_CLIENT
        ) {
          this.setState({ showClientFields: true, showGOLFields: true });
        }
        if (
          this.state.impactOptionSelected.label === VD_TO_GENPACT
        ) {
          this.setState({ showClientFields: false, showGOLFields: true });
        }
        if (
          this.state.impactOptionSelected.label ===
          VD_TO_CLIENT_PLUS_GENPACT
        ) {
          this.setState({ showClientFields: true, showGOLFields: true });
        }
      });
  };

  fetchFPAOHRforIncreaseInRevenue = (e) => {
    if (e === true) {
      this.setState({ appropriateAttachment: true }, () => { });
    } else {
      this.setState({ appropriateAttachment: false }, () => { });
    }
  };
  pull_monetization_sowId = (localSowId) => {
    this.setState({ SowID: localSowId }, () => {
      //console.log("sow id from pull_monetization_sowId function =>",this.state.SowID)
    });
  };

  pullMonetizationGOLName = (localGOLName) => {
    this.setState({ golMonetizationName: localGOLName }, () => {
      //console.log(this.state.golMonetizationName)
    });
  };
  pullMonetizationGOLOhr = (localGOLOhr) => {
    this.setState({ golMonetizationOhr: localGOLOhr }, () => {
      //console.log(this.state.golMonetizationOhr)
    });
  };

  pullCategoryNotListed = (localShowHref) => {
    this.setState({ showHrefModal: localShowHref }, () => {
      console.log("hrf modal =>", this.state.showHrefModal)
    });
  };

  // function for FPNAGOL component starts here

  // ppt deck file details
  pullPPTDeck = (fileName, fileType, fileContent) => {
    this.setState(
      { filename1: fileName, fileType1: fileType, base64File1: fileContent },
      () => {
        //console.log("filename ",this.state.filename1, "file type ",this.state.fileType1, "content ",this.state.base64File1)
      }
    );
  };
  pullClientDocName = (fileName) => {
    this.setState({ signOffFilename: fileName }, () => {
      //console.log("client approval name =>",this.state.signOffFilename)
    });
  };
  pullClientDocType = (fileType) => {
    this.setState({ signOffFileType: fileType }, () => {
      //console.log("client approval type =>",this.state.signOffFileType)
    });
  };
  pullClientDocContent = (fileContent) => {
    this.setState({ signOffContent: fileContent }, () => {
      //console.log("client approval contnet =>",this.state.signOffContent)
    });
  };

  // gol file details
  pullgolFileName = (fileName) => {
    this.setState({ filename3: fileName }, () => {
      //console.log("gol approval doc name",this.state.filename3)
    });
  };
  pullgolFileType = (fileType) => {
    this.setState({ fileType3: fileType }, () => {
      //console.log("gol approval doc type",this.state.fileType3)
    });
  };
  pullgolContent = (fileContent) => {
    this.setState({ base64File3: fileContent }, () => {
      //console.log("gol approval doc content",this.state.base64File3)
    });
  };

  // fpna file details
  pullfpnafileName = (fileName) => {
    this.setState({ filename4: fileName }, () => {
      //console.log("fpna doc name",this.state.filename4)
    });
  };
  pullfpnafileType = (fileType) => {
    this.setState({ fileType4: fileType }, () => {
      //console.log("fpna doc type",this.state.fileType4)
    });
  };
  pullfpnafileContent = (fileContent) => {
    this.setState({ base64File4: fileContent }, () => {
      //console.log("fpna doc file content",this.state.base64File4)
    });
  };

  pullClientName = (e) => {
    this.setState({ clientName: e }, () => {
      console.log(this.state.clientName)
    });
  };
  pullClientRole = (e) => {
    this.setState({ clientRole: e }, () => {
      console.log(this.state.clientRole)
    });
  };
  pullClientSignOff = (e) => {
    this.setState({ clientSignOffDate: e }, () => {
      //console.log(this.state.clientSignOffDate)
    });
  };
  pullFpnaName = (name) => {
    this.setState({ fpnaName: name }, () => {
      //console.log(this.state.fpnaName)
    });
  };
  pullGolName = (name) => {
    this.setState({ golFullname: name }, () => {
      //console.log(this.state.golFullname)
    });
  };
  pullFpnaOhr = (e) => {
    this.setState({ fpnaOhr: e }, () => {
      //console.log(this.state.fpnaOhr)
    });
  };
  pullGolOhr = (e) => {
    this.setState({ golOhr: e }, () => {
      //console.log(this.state.golOhr)
    });
  };
  pull_fileDetails = (obj) => {
    this.setState({ golFpnaFileDetails: obj }, () => {
      //console.log(this.state.golFpnaFileDetails)
    });
  };

  // function for FPNAGOL component ends here

  // clustering function starts here
  showClusterModal = () => {
    if (
      this.state.ideaItem.LeanID !== "" ||
      this.state.ideaItem.LeanID !== null ||
      this.state.ideaItem.LeanID !== undefined ||
      !this.state.ideaItem.LeanID
    ) {
      this.setState({
        clusterModal: !this.state.clusterModal,
      });
    }
  };
  changeProjectType = async(e) => {
    this.setState({ projectIDSelectedOption: null }, () => { });
    if (e) {
      this.setState({ projectTypeSelectedOption: e }, () => {
        Toast.loading("Fetching Cluster Projects...", () => { });
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.accessToken,
          },
        };
        let encodedAccount = encodeURIComponent(
          this.state.ideaItem.AccountManual
        );
        let encodedVertical = encodeURIComponent(
          this.state.ideaItem.VerticalManual
        );
        fetch(
          `${GET_IDEA_URL}Account=${encodedAccount}&Vertical=${encodedVertical}&ProjectType=${this.state.projectTypeSelectedOption.label}&IdeaId=${this.state.ideaItem.IdeaId}&case=data&casetype=fetchclusterprojects&mucid=muc001`,
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            Toast.hide();
            this.setState(
              {
                clustorProjects: data.ClusterProjects,
              },
              () => { }
            );
          })
          .catch((error) => {
            Toast.fail(
              "Error while fetching cluster projects. Please try again!",
              3000,
              () => { }
            );
            Toast.hide();
            console.log(error);
          });
      });
    }
  };

  displayProjectID = () => {
    if (this.state.clustorProjects) {
      let options = [];
      if (this.state.clusterOptionSearched) {
        this.state.clustorProjects.map((item, index) => {
          options.push({
            value: index,
            Display: item.pg_projectid,
            label: item.pg_projectid + " - " + item.pg_projowner,
          });
        });
      } else {
        this.state.clustorProjects.map((item, index) => {
          if (index < 19) {
            options.push({
              value: index,
              Display: item.pg_projectid,
              label: item.pg_projectid + " - " + item.pg_projowner,
            });
          }
        });
      }
      return options;
    }
  };

  handleClusterProjectInputChange = (inputValue) => {
    if (inputValue && inputValue.length > 0) {
      this.setState({ clusterOptionSearched: true }, () => { });
    } else {
      this.setState({ clusterOptionSearched: false }, () => { });
    }
  };

  changeProjectID = (e) => {
    this.setState(
      { projectIDSelectedOption: e, isClusterSaveDisabled: false },
      () => {
        this.state.clustorProjects.map((item, index) => {
          if (
            item.pg_projectid === this.state.projectIDSelectedOption.Display
          ) {
            this.setState({ guid: item.msdyn_projectid }, () => { });
          }
        });
      }
    );
  };

  saveParentLink = async () => {
    if (
      this.state.ideaItem.ApprovalStatus &&
      this.state.ideaItem.ApprovalStatus !== "Rejected" &&
      this.state.projectTypeSelectedOption &&
      this.state.projectIDSelectedOption
    ) {
      if (
        window.confirm(
          "Are you sure you'd like to add Project ID: " +
          this.state.projectIDSelectedOption.Display +
          " as the Parent Project ID?"
        )
      ) {
        if (
          parseInt(this.state.ideaItem.OwnerOHR) ===
          parseInt(this.sessionData.profile.oHRId) ||
          parseInt(this.state.ideaItem.BlackBeltUserId) ===
          parseInt(this.sessionData.profile.oHRId)
        ) {
          if (
            this.state.projectTypeSelectedOption &&
            this.state.projectIDSelectedOption
          ) {
            Toast.loading("Linking...", () => { });
            let param = {
              case: "new",
              casetype: "updatecluster",
              RecID: this.props.location.state,
              RecAlpha: this.state.ideaItem.LeanID,
              ParentRecID: this.state.guid,
              ParentProjectType: this.state.projectTypeSelectedOption
                ? this.state.projectTypeSelectedOption.label
                : "",
              ParentAlpha: this.state.projectIDSelectedOption
                ? this.state.projectIDSelectedOption.Display
                : "",
              UpdatedByName: this.sessionData
                ? this.sessionData.profile.lastName +
                ", " +
                this.sessionData.profile.firstName
                : "",
              UpdatedByOHR: this.sessionData
                ? this.sessionData.profile.oHRId
                : " ",
              Vertical: this.state.ideaItem
                ? this.state.ideaItem.VerticalManual
                : "",
              Account: this.state.ideaItem
                ? this.state.ideaItem.AccountManual
                : "",
            };
            console.log(param);
            
            const requestOptions = {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.accessToken,
              },
              body: JSON.stringify(param),
            };
            fetch(
              `${DELEGATE_IDEA_URL}`,
              requestOptions
            )
              .then((response) => response.json())
              .then((data) => {
                Toast.success("Parent linked successfully!", 5000, () => {
                  this.setState({
                    clusterModal: !this.state.clusterModal,
                  });
                  this.updateClusterData();
                });
                this.setState({ isClusterSaveDisabled: true }, () => { });
              })
              .catch((error) => {
                console.log(error);
                Toast.fail("Parent linked failed", 3000, () => { });
              });
          } else {
            Toast.fail(
              "Please select project type & project ID",
              3000,
              () => { }
            );
          }
        } else {
          Toast.fail(
            "Only idea owner & idea BB can link the ideas",
            3000,
            () => { }
          );
        }
      }
    } else {
      Toast.fail("Rejected ideas cannot be linked.", 3000, () => { });
    }
  };
  removeParentFunc = () => {
    console.log(this.state.projectIDSelectedOption);
    if (
      this.state.ideaItem.ApprovalStatus &&
      this.state.ideaItem.ApprovalStatus !== "Rejected"
    ) {
      if (
        parseInt(this.state.ideaItem.OwnerOHR) ===
        parseInt(this.sessionData.profile.oHRId) ||
        parseInt(this.state.ideaItem.BlackBeltUserId) ===
        parseInt(this.sessionData.profile.oHRId)
      ) {
        if (!this.state.clusterData || this.state.clusterData.length === 0) {
          if (
            (this.state.projectTypeSelectedOption === null ||
              this.state.projectTypeSelectedOption === undefined ||
              !this.state.projectTypeSelectedOption) &&
            (this.state.projectIDSelectedOption === null ||
              this.state.projectIDSelectedOption === undefined ||
              !this.state.projectIDSelectedOption)
          ) {
            Toast.fail("Only linked ideas can only be removed", 3000, () => { });
          }
        }
        if (this.state.clusterData && this.state.clusterData.length > 0) {
          console.log(this.state.projectIDSelectedOption);
          if (
            this.state.projectTypeSelectedOption &&
            this.state.projectIDSelectedOption
          ) {
            if (
              window.confirm(
                "Are you sure you'd like to remove Project ID: " +
                this.state.projectIDSelectedOption.label +
                " as the Parent Project ID?"
              )
            ) {
              Toast.loading("Removing parent link...", () => { });
              let param = {
                case: "new",
                casetype: "updatecluster",
                RecID: this.props.location.state,
                RecAlpha: this.state.ideaItem.LeanID,
                ParentRecID: "",
                ParentAlpha: "",
                ParentProjectType: "",
                UpdatedByName: this.sessionData
                  ? this.sessionData.profile.lastName +
                  ", " +
                  this.sessionData.profile.firstName
                  : "",
                UpdatedByOHR: this.sessionData
                  ? this.sessionData.profile.oHRId
                  : " ",
                Vertical: this.state.ideaItem
                  ? this.state.ideaItem.VerticalManual
                  : "",
                Account: this.state.ideaItem
                  ? this.state.ideaItem.AccountManual
                  : "",
              };
              console.log(param);
             
              const requestOptions = {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param),
              };
              fetch(
                `${DELEGATE_IDEA_URL}`,
                requestOptions
              )
                .then((response) => response.json())
                .then((data) => {
                  Toast.success("Parent unlinked successfully!", 3000, () => {
                    this.setState({
                      clusterModal: !this.state.clusterModal,
                    });
                  });
                  this.updateClusterData();
                  this.setState(
                    {
                      projectTypeSelectedOption: null,
                      projectIDSelectedOption: null,
                    },
                    () => { }
                  );
                })
                .catch((error) => {
                  console.log(error);
                  Toast.fail("Parent unlinked failed", 3000, () => { });
                });
            }
          }
        }
      } else {
        Toast.fail(
          "Only idea owner & idea BB can unlink the Parent",
          3000,
          () => { }
        );
      }
    } else {
      Toast.fail(
        "Rejected ideas cannot be unlinked / removed.",
        3000,
        () => { }
      );
    }
  };
  updateClusterData = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          console.log("fetch idea for cluster data", data);
          this.setState(
            {
              ideaItem: data.ResultSets.Table1[0],
              clusterData: data.ClusterData ? data.ClusterData : [],
            },
            () => {
              if (this.state.clusterData && this.state.clusterData.length > 0) {
                const targetRecID = this.state.ideaItem.LeanID;
                const filteredData = this.state.clusterData.filter(
                  (item) => item.RecAlpha === targetRecID
                );

                let getParentAlpa = "";
                this.state.clusterData.map((item) => {
                  if (item.RecAlpha === targetRecID) {
                    getParentAlpa = item.ParentAlpha;
                  }
                });
                if (getParentAlpa) {
                  this.state.clusterData.map((item) => {
                    if (getParentAlpa === item.RecAlpha) {
                      const selectedOptionProjectType = {
                        value: 0,
                        label: item.ProjectType,
                      };
                      this.state.projectTypeSelectedOption =
                        selectedOptionProjectType;
                      this.setState(
                        { projectTypeSelectedOption: selectedOptionProjectType },
                        () => {
                          //console.log(this.state.projectTypeSelectedOption)
                        }
                      );
                    }
                  });
                }
                if (
                  filteredData &&
                  filteredData.length > 0 &&
                  filteredData !== undefined &&
                  filteredData !== null &&
                  filteredData !== ""
                ) {
                  this.setState(
                    { displayParentAlpha: filteredData[0].ParentAlpha },
                    () => { }
                  );
                  const selectedOption = {
                    value: 0,
                    label: filteredData[0].ParentAlpha,
                  };
                  this.setState(
                    { projectIDSelectedOption: selectedOption },
                    () => {
                      this.setState(
                        { projectIDSelectedOption: selectedOption },
                        () => {
                          if (
                            this.state.projectTypeSelectedOption &&
                            (this.state.projectTypeSelectedOption.label ===
                              null ||
                              this.state.projectTypeSelectedOption.label === "")
                          ) {
                            if (
                              this.state.projectIDSelectedOption.label.startsWith(
                                "GB"
                              )
                            ) {
                              const selectedOptionGB = {
                                value: 0,
                                label: "GB",
                              };
                              this.state.projectTypeSelectedOption =
                                selectedOptionGB;
                              this.setState(
                                { projectTypeSelectedOption: selectedOptionGB },
                                () => {
                                  //console.log(this.state.projectTypeSelectedOption)
                                }
                              );
                            } else {
                              const selectedOptionBB = {
                                value: 0,
                                label: "BB",
                              };
                              this.state.projectTypeSelectedOption =
                                selectedOptionBB;
                              this.setState(
                                { projectTypeSelectedOption: selectedOptionBB },
                                () => {
                                  //console.log(this.state.projectTypeSelectedOption)
                                }
                              );
                            }
                          }
                        }
                      );
                    }
                  );
                } else {
                  this.setState({ displayParentAlpha: "" }, () => { });
                }
              } else {
                this.setState({ displayParentAlpha: "" }, () => { });
              }
            }
          );

        }
      }


    }
    catch (error) {
      console.log(error)
      Toast.hide();
      Toast.fail("Error while fetching idea. Please try again!", 3000, () => { });
    }
  }
  // clustering function ends here
  
  handleLDTLeadOptionChange = (e) => {
    if (
      parseInt(e.value) === parseInt(this.state.ideaItem.OwnerOHR) ||
      parseInt(e.value) === parseInt(this.state.ideaItem.CreatorOHR)
    ) {
      Toast.fail(
        "LDT user cannot be the same as Idea Owner/Requester. Please select a different LDT user.",
        3000,
        () => {
          return;
        }
      );
      return;
    }
    
    this.setState({
      ldtOHR:e.value,
      ldtName:e.label,
      ldtSelectedOption: {
        value: e.value,
        label: e.label,
      },
    });
  };
  
  handleMBBChange = (e) => {
    if (
      parseInt(e.value) === parseInt(this.state.ideaItem.OwnerOHR) ||
      parseInt(e.value) === parseInt(this.state.ideaItem.CreatorOHR)
    ) {
      Toast.fail(
        "Master Black Belt user cannot be the same as Idea Owner/Requester. Please select a different Master Black Belt user.",
        3000,
        () => {
          return;
        }
      );
      return;
    }
    // let styleStateObj = this.state.selectStyle;
    // styleStateObj.mbbUserName = selectStyle(true);
    this.setState({
      mbbName: e.label,
      mbbOHR: e.value,
      mbbSelectedOption: {
        value: e.value,
        label: e.label,
      },
    });
  };
  // Code change bh TR - sugg by AB
  renderMBBOptions = () => {
    let options = [];
    let result = [];
    this.state.mbbList.map((item) => {
      const userRole = JSON.parse(item.pg_Role).pg_role;
      if (userRole === "MBB") {
        if (this.state.ideaItem.OwnerOHR !== item.pg_ohr) {
          options.push({ value: item.pg_ohr, label: item.pg_username });
        }
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);
    return result;
  };
  // Code change bh TR - sugg by AB

  renderLeadOptions = () => {
    let options = [];
    const uniqueLeadList = [
      ...new Map(
        this.state.leadNameList.map((item) => [item.pg_ohr, item])
      ).values(),
    ];
  
    uniqueLeadList.map((item) => {
      options.push({ value: item.pg_ohr, label: item.pg_username });
      return options;
    });
    return options;
  };



  handleCoderOHRAdd = () => {
    if (this.state.codersLoading) {
      console.log("Please wait, still adding the previous Coder ohr.");
      return;
    }
    if (this.state.CodersTable.length < 10) {
      let localOHR = this.state.individualCoderOHR
      if (localOHR.length === 9) {
        let OHRExist = this.state.CodersTable && this.state.CodersTable.some((item) => item.OHR === localOHR)
        if (OHRExist) {
          Toast.info('Coder OHR already exist', 3000)
          this.setState({ individualCoderOHR: "" })
          return
        } else {
          this.setState({
            codersLoading: true
          }, () => {
            this.fetchSubmitCoderOHR(localOHR).finally(() => {
              this.setState({ codersLoading: false })
            })

          })
        }
      } else {
        Toast.info("OHR should consist of 9 digits", 3000)
        return
      }
    } else {
      Toast.fail("Max 10 Coder OHRs are allowed.", 3000, () => { })
    }
  }

  handleCoderOHRKeyDown = (e) => {
    if (e.key === "Enter") {
      this.handleCoderOHRAdd()
    }
  }

  handleCoderOhrOnChange = (event) => {
    var numbers = /^[0-9]*$/;
    if (event !== null && event !== undefined) {
      if (event.target.value.match(numbers)) {
        let localCoderOHR = event.target.value.trim();
        this.setState({ individualCoderOHR: localCoderOHR }, () => {
        })
      }
    }
  }
  handleCoderOHRdelete = (index) => {
    if (window.confirm("Are you sure you want to delete the coder OHR ?")) {
      const { CodersTable } = this.state;
      const updatedItems = CodersTable.filter((_, i) => i !== index);
      this.setState({ CodersTable: updatedItems }, () => { });
    }
  }
  
  fetchSubmitCoderOHR = async (localCoderOHR) => {
    try {
      Toast.loading("Fetching Coder's full name, please wait...")
      const param = {
        EntityType: "OHR",
        EntityName: localCoderOHR
      }
      const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,

        },
        body: JSON.stringify(param)
      };
      const response = await fetch(GET_METADATA, requestOptions);
      const data = await response.json();
      console.log(data);
      let requestByName = "";
      if (data.DNAUsers) {
        if (data.DNAUsers.Table1 && data.DNAUsers.Table1.length > 0) {
          requestByName = data.DNAUsers.Table1[0].pg_username;
        }
      }
      Toast.hide();
      if (requestByName === "" || requestByName === null || !requestByName) {
        Toast.fail("We could not find Coder's full name details based on the entered OHR. Please check and re-enter.", 5000, () => { });
      } else {
        let newUser = {
          OHRName: requestByName,
          OHR: localCoderOHR
        }
        this.setState((prevState) => ({
          CodersTable: [...prevState.CodersTable, newUser]
        })
        )
        console.log("coders ohr =>", this.state.CodersTable)
      }
      Toast.hide();
      this.setState({ individualCoderOHR: "" })

    } catch (error) {
      Toast.hide();
      Toast.fail('Please enter a valid Coder OHR', 5000, () => {
        console.log(JSON.stringify(error));
      });
      this.setState({ individualCoderOHR: "" })
    }
  };


  displayCoderSection = () => {
    let displayCoderSection = false;
    this.state.digitalProjectTypeList && this.state.digitalProjectTypeList.map((item) => {
      if (item.IsCoder === 1 || item.IsCoder === "1" || item.IsCoder === true || item.IsCoder === 'true') {
        if(this.state.digitalProjectTypeSelectedOptions?.label === item.DPType){
          displayCoderSection = true;
        }
      }
    })
    return displayCoderSection
  }


  checkifCoderTableUpdated = (prevArray, newArray) => {
    if (prevArray.length !== newArray.length) return true;
    let changed = false;
    prevArray.map((item) => {
      const found = newArray.some(newItem => newItem.OHR === item.OHR);
      if (!found) {
        changed = true;
      }
    });
    console.log("coders table has changed or no =>", changed)
    return changed;
  }

  checkIsFteEquivalentPresent = (SrNo) => {
        let myBIMasterList = this.state.businessImpactMasterList;
        for (const pg_item of myBIMasterList) {
            if (SrNo === pg_item.pg_srno) {
                if (pg_item.pg_isohruploaded === "FTE") {
                    return true;
                }
            }
        }
        return false;
    }

  render() {
   
    let convertIdeaID = window.btoa(this.state.ideaItem.IdeaId);
    let IDEA_APPROVED = this.state.ideaItem.WorkflowStatus === "Approve";
    let IDEA_REJECTED = this.state.ideaItem.WorkflowStatus === "Reject";
    let IDEA_SEND_BACK = this.state.ideaItem.WorkflowStatus === "Send Back";

    return (
      <>
        <section className="u-clearfix u-section-1" id="sec-0f7f">
          <div
            className="u-clearfix u-sheet u-sheet-1"
            style={{ marginBottom: 20 }}
          >
            <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
              <div className="u-container-layout u-container-layout-1">
                {/* ...clustor btn group starts here..... */}
                <div className="row">
                                            <div className="col-md-8">&nbsp;</div>
                                            <div className="col-md-4">
                                                <div className="cluster_modal_btn_group">
                                                    <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-white u-btn u-btn-round  u-radius-6 u-btn-3 update_parent_btn" onClick={this.showClusterModal}>Update Parent</button>
                                                    <button tabIndex={21} className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6" onClick={this.cancelProject}>Cancel Project</button>
                                                </div>
                                            </div>
                                        </div>

                <div className="">
                {this.state.cancelProjDirect ? (
                  <>
                    <div className="custom_modal">
                      <div
                        className="modal_body"
                        style={{ width: "700px", overflow: "hidden" }}
                      >
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="modal_title">
                                Cancel Project
                            </h3>
                          </div>
                          <div className="col-md-4">
                            <button
                              type="button"
                              className="close text-right"
                              onClick={(e) =>
                                this.setState({ cancelProjDirect: false })
                              }
                            >
                              &times;
                            </button>
                          </div>
                        </div>

                        <div className="cancellation_alert_msg">
                          <div className="">
                            <label style={{ color: "red" }}>Note: Once cancelled you cannot have the project reinitiated. You will need to start the project from scratch.</label>
                          </div>
                        </div>


                        

                        <div className="row">
                          <div className="col-md-10">
                            <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                              <span className="u-text-black form-attribute">
                                <span style={{ color: "red" }}>*</span>
                                &nbsp;Comments
                                <span
                                  style={{
                                    fontWeight: "normal",
                                    fontSize: 12,
                                    fontStyle: "italic",
                                    color: "grey",
                                  }}
                                >
                                  {" "}
                                  (max. 500 chars)
                                </span>
                              </span>
                            </p>
                          </div>
                          {/* <div
                            className="col-md-2"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            <img
                              onClick={(e) => this.toggleTranscriptFunction(3)}
                              src={require("../assets/images/voice.png")}
                              className="w100"
                              alt=""
                              style={{ width: "24px", cursor: "pointer" }}
                            />
                          </div> */}
                        </div>
                        <div className="row" style={{ marginTop: 5 }}>
                          <div className="col-md-12">
                            <textarea
                              className="textarea-css form-attribute"
                              style={{
                                maxWidth: "100%",
                                border: "1px solid lightgrey",
                                ...this.state.selectStyle.cancelComment,
                              }}
                              rows={3}
                              cols={88}
                              placeholder="Please provide your comments on reason for cancellation."
                              onChange={(e) =>
                                this.handleCancelCommentChange(e.target.value)
                              }
                              value={this.state.cancelComment}
                            />
                          </div>
                        </div>
                        <div className="btn-group" style={{ marginTop: 10 }}>
                          <button
                            className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                            onClick={this.submitEvent}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
                  {this.state.clusterModal ? (
                    <>
                      <div className="cluster_modal_main_block">
                        <div className="custom_modal cluster_modal_block">
                          <div
                            className="modal_body"
                            style={{ width: "400px" }}
                          >
                            <div className="row">
                              <div className="col-md-11">
                                <h3 className="modal_title text-center">
                                  Update Parent
                                </h3>
                              </div>
                              <div className="col-md-1">
                                <button
                                  type="button"
                                  className="close text-right"
                                  onClick={(e) =>
                                    this.setState({ clusterModal: false })
                                  }
                                >
                                  &times;
                                </button>
                              </div>
                            </div>
                            <div className="clustor_modal_fields_block">
                              <div className="clustor_modal_field">
                                <label className="form-attribute">
                                  <span style={{ color: "red" }}>*</span>{" "}
                                  Project Type:
                                </label>
                                {this.state.displayParentAlpha ? (
                                  <>
                                    <input
                                      disabled={true}
                                      value={
                                        this.state.projectTypeSelectedOption &&
                                          this.state.projectTypeSelectedOption
                                            .label
                                          ? this.state.projectTypeSelectedOption
                                            .label
                                          : ""
                                      }
                                      className="form-input"
                                      placeholder="Choose project type"
                                    />
                                  </>
                                ) : (
                                  <Select
                                    isSearchable={false}
                                    options={projectType}
                                    value={this.state.projectTypeSelectedOption}
                                    styles={this.state.selectStyle.projectType}
                                    placeholder="Choose project type"
                                    onChange={this.changeProjectType}
                                  />
                                )}
                              </div>
                              <div className="clustor_modal_field">
                                <label className="form-attribute">
                                  <span style={{ color: "red" }}>*</span>{" "}
                                  Project ID:
                                </label>
                                {this.state.displayParentAlpha ? (
                                  <>
                                    <input
                                      value={
                                        this.state.projectIDSelectedOption &&
                                          this.state.projectIDSelectedOption.label
                                          ? this.state.projectIDSelectedOption
                                            .label
                                          : ""
                                      }
                                      disabled={true}
                                      className="form-input"
                                      placeholder="Choose project ID"
                                    />
                                  </>
                                ) : (
                                  <Select
                                    isSearchable
                                    onInputChange={
                                      this.handleClusterProjectInputChange
                                    }
                                    options={this.displayProjectID()}
                                    value={this.state.projectIDSelectedOption}
                                    styles={
                                      this.state.selectStyle
                                        .projectIDSelectedOption
                                    }
                                    isDisabled={
                                      this.state.projectTypeSelectedOption
                                        ? false
                                        : true
                                    }
                                    placeholder="Choose project ID"
                                    onChange={this.changeProjectID}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="cluster_modal_btn_group">
                              <button
                                className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                disabled={
                                  this.state.isClusterSaveDisabled
                                    ? true
                                    : false
                                }
                                onClick={this.saveParentLink}
                              >
                                Save
                              </button>
                              <button
                                className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6"
                                onClick={this.removeParentFunc}
                                style={{ marginRight: "15px" }}
                              >
                                Remove Parent
                              </button>
                              {this.state.displayParentAlpha ? (
                                <>
                                  <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6 show_hierarchy_link_btn">
                                    <Link
                                      className="show_hierarchy_link_btn_anchor"
                                      to={`/showTree?ID=${this.state.ideaItem.IdeaId}`}
                                      target="_blank"
                                    >
                                      Show Hierarchy
                                    </Link>
                                  </button>
                                </>
                              ) : (
                                <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6 show_hierarchy_link_btn">
                                  Show Hierarchy
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {/* ....cluster modal ends here.... */}
                </div>

                {/* ....clustor btn group ends here.... */}
                <h4
                  style={{
                    fontWeight: "bold",
                    textAlign: "center",
                    color: "#00AECF",
                    fontFamily: "Arial",
                    fontSize: 22,
                  }}
                >
                  Idea Final Review :{" "}
                  {this.state.ideaItem.IdeaIDAlpha
                    ? this.state.ideaItem.IdeaIDAlpha
                    : this.state.ideaItem.IdeaId}{" "}
                </h4>
                <div className="u-align-left u-container-style u-expanded-width u-group u-shape-rectangle u-group-2">
                  <div
                    className="u-container-layout u-container-layout-2"
                    style={{ textAlign: "center" }}
                  >
                    <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-3">
                      <div className="u-container-layout u-container-layout-3">
                        <p
                          className="u-align-left u-text u-text-2"
                          style={{ marginBottom: 10 }}
                        >
                          Owner details
                        </p>
                        <div className="row">
                          <div className="col-md-5">
                            <span className="form-attribute">Owner OHR</span>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              value={this.state.ideaItem.OwnerOHR}
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: 15 }} />
                        <div className="row">
                          <div className="col-md-5">
                            <span className="form-attribute">Owner Name</span>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              value={this.state.ideaItem.OwnerName}
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: -10 }} />
                        <p
                          className="u-align-left u-text u-text-7 u-text-custom-color-3"
                          style={{ fontSize: 11, marginBottom: 10 }}
                        >
                          (If Idea was raised for someone else, their OHR ID is
                          below)
                        </p>
                        <div className="row">
                          <div className="col-md-5">
                            <span className="form-attribute">
                              Request For OHR
                            </span>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              value={this.state.ideaItem.CreatorOHR}
                              onChange={this.handleCreatorOHRChange}
                              placeholder="Enter OHR"
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: 10 }} />
                        <div className="row">
                          <div className="col-md-5">
                            <span className="form-attribute">Name</span>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              value={this.state.ideaItem.CreatorName}
                              onChange={this.handleCreatorNameChange}
                              placeholder="Auto Load Name"
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: 10 }} />
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Project ID
                            </label>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              defaultValue={this.state.ideaItem.LeanID}
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: 10 }} />
                      </div>
                    </div>

                    <p
                      className="visible-md-block visible-sm-block visible-xs-block"
                      style={{ marginTop: 235 }}
                    >
                      &nbsp;
                    </p>

                    <div
                      className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-4"
                      style={{ marginTop: "-303px" }}
                    >
                      <div
                        className=""
                        style={{ display: "flex", marginTop: "30px" }}
                      >
                        <div className="u-container-style u-group u-shape-rectangle u-group-5">
                          <div className="u-container-layout u-container-layout-5">
                            <p
                              className="u-align-left u-text u-text-8"
                              style={{ marginBottom: 13 }}
                            >
                              Account Details
                            </p>
                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  Account&nbsp;Name
                                </span>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  list="accounts"
                                  name="accounts"
                                  placeholder="Choose Account"
                                  value={this.state.ideaItem.AccountManual}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Holding&nbsp;Account
                                </label>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  type="text"
                                  value={this.state.ideaItem.HoldingAccount}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">Vertical</span>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  list="vertical"
                                  name="vertical"
                                  placeholder="Choose Vertical"
                                  value={this.state.ideaItem.VerticalManual}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  Industry&nbsp;Vertical
                                </span>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  list="ideationtype"
                                  name="ideationtype"
                                  placeholder="Choose Industry&nbsp;Vertical"
                                  value={this.state.ideaItem.SubVerticalName}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />

                            {/* units and segments starts here */}
                            <div className="row">
                              <div className="col-md-5">
                                <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Segment</label>
                              </div>
                              <div className="col-md-7">
                                <input className="form-input" disabled name="segment" value={this.state.ideaItem.Segment ? this.state.ideaItem.Segment : ""} style={{ fontWeight: 'normal !important' }} />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Unit</label>
                              </div>
                              <div className="col-md-7">
                                <input className="form-input" disabled name="unit" value={this.state.ideaItem.Unit ? this.state.ideaItem.Unit : ""} style={{ fontWeight: 'normal !important' }} />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            {/* units and segments ends here */}


                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  Campaign&nbsp;Name
                                </span>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  list="campaign"
                                  name="campaign"
                                  placeholder="Choose Idea Type"
                                  value={this.state.ideaItem.CampaignName}
                                />
                              </div>

                              <div className="">
                                <div className="campaign_modal_bulb campaign_tool_tip">
                                  <img
                                    src={require("../assets/images/question_mark_2.png")}
                                    alt=""
                                    className=""
                                  />
                                  {
                                    this.state.campaignInsight
                                      ?
                                      <>
                                        <span className="my_tooltiptext">{this.state.campaignInsight}</span>
                                      </>
                                      :
                                      null
                                  }
                                </div>
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />

                            {
                              this.state.ideaItem.SubCampaignName && (
                                <div className="row" style={{ marginBottom: 15 }}>
                                  <div className="col-md-5" >
                                    {
                                      this.state.ideaItem.CampaignName === "Gen AI"
                                        ?
                                        <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Gen AI Theme</label>
                                        :
                                        <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Sub Campaign</label>
                                    }
                                  </div>
                                  <div className="col-md-7">
                                    <input
                                      className="form-input"
                                      disabled
                                      list="subcampaign"
                                      name="subcampaign"
                                      placeholder="Sub Campaign"
                                      value={this.state.ideaItem.SubCampaignName}
                                    />
                                  </div>
                                </div>
                              )

                            }

                            {this.state.displayProjectTheme &&
                              this.state.ideaItem.CampaignName === DATA_BRIDGE_CAMPAIGN && (
                                <>
                                  <div className="row" style={{ marginBottom: 15 }}>
                                    <div className="col-md-5">
                                      <label
                                        style={{
                                          verticalAlign: "bottom",
                                          marginBottom: -5,
                                        }}
                                      >
                                        Data Bridge Project Theme
                                      </label>
                                    </div>
                                    <div className="col-md-7">
                                      <input
                                        className="form-input"
                                        disabled
                                        list="databridgetype"
                                        name="databridgetype"
                                        placeholder="Choose Data Bridge Project Type"
                                        value={
                                          this.state.ideaItem.DataBridgeTheme
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div  />
                                </>
                              )}
                            

                            {this.state.displayParentAlpha &&
                              this.state.displayParentAlpha.length > 0 &&
                              this.state.displayParentAlpha !== null &&
                              this.state.displayParentAlpha !== undefined &&
                              this.state.displayParentAlpha !== "" ? (
                              <>
                                <div className="row" style={{marginBottom:"15px"}}>
                                  <div className="col-md-5">
                                    <label
                                      style={{
                                        verticalAlign: "bottom",
                                        marginBottom: -5,
                                      }}
                                    >
                                      Parent ID
                                    </label>
                                  </div>
                                  <div className="col-md-7">
                                    <input
                                      className="form-input"
                                      disabled
                                      placeholder="Choose Parent ID"
                                      value={this.state.displayParentAlpha}
                                    />
                                  </div>
                                </div>
                              </>
                            ) : null}
                            
                            {
                              this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST
                                ?
                                <>
                                  <div className="row" style={{ marginBottom: 15 }}>
                                    <div className="col-md-5">
                                      <label
                                        style={{
                                          verticalAlign: "bottom",
                                          marginBottom: -5,
                                        }}
                                      >
                                        <i>AI First Sample Ideas</i>
                                      </label>
                                    </div>
                                    <div className="col-md-7">
                                      <div className="ai_first_doc_link ai_first_doc_red_highlight">
                                        <a
                                          className="ldt-list1"
                                          href={AI_DOC_LINK}
                                          target="_blank"
                                          rel="noreferrer"
                                          style={{ textAlign: "left", fontSize: 16, color: "red" }}
                                        >Document Link </a>
                                      </div>

                                    </div>
                                  </div>

                                  {
                                    this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                      ?
                                      <>
                                        <div style={{ marginBottom: 20 }} />
                                        <div className="row d_flex_align_items_center">
                                          <div className="col-md-5">
                                            <span className="form-attribute">
                                              AI Recommendation
                                            </span>
                                          </div>
                                          <div className="col-md-7">
                                            <input
                                              className="form-input"
                                              disabled
                                              name="methodology"
                                              value={this.state.ideaItem.isAI}
                                            />
                                          </div>
                                        </div>
                                      </>
                                      :
                                      null

                                  }


                                  {
                                    this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                      ?
                                      <>
                                        <div style={{ marginBottom: 20 }} />
                                        <div className="row">
                                          <div className="col-md-5">
                                            <span className="form-attribute">
                                              AI First BRD
                                            </span>
                                          </div>
                                          <div className="col-md-7">
                                            <div className="ai_first_doc_link">
                                              <textarea className="ai_first_brd_textarea" disabled value={this.state.ideasAI.LinkBRD} ></textarea>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                      :
                                      null
                                  }

                                </>
                                :
                                null
                            }
                          </div>
                        </div>
                        <div className="u-container-layout u-container-layout-6">
                          <div className="row" style={{ marginTop: "10px" }}>
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Country
                              </label>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                list="country"
                                name="country"
                                placeholder="Choose Country"
                                value={this.state.ideaItem.Country}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <span className="form-attribute">Region</span>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                list="regions"
                                name="regions"
                                placeholder="Choose Region"
                                value={this.state.ideaItem.RegionManual}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Sub-Region
                              </label>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                list="subregions"
                                name="subregions"
                                placeholder="Choose Sub-Region"
                                value={this.state.ideaItem.SubRegion}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <span className="form-attribute">
                                Blackbelt&nbsp;Name
                              </span>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                list="blackbelt"
                                name="blackbelt"
                                placeholder="Choose Blackbelt"
                                title={
                                  "OHR ID: " +
                                  this.state.ideaItem.BlackBeltUserId
                                }
                                value={this.state.ideaItem.BlackBeltUserName}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                MBB
                              </label>
                            </div>
                            <div className="col-md-7">
                            <Select
                                // tabIndex={10}
                                // isSearchable={true}
                                value={this.state.mbbSelectedOption}
                                options={this.renderMBBOptions()}
                                styles={this.state.selectStyle.mbbName}
                                placeholder="Choose MBB"
                                onChange={this.handleMBBChange}
                              />

                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />


                          {
                            this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST &&
                              this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                              ?
                              <>
                                <div style={{ marginBottom: 20 }} />
                                <div className="row">
                                  <div className="col-md-12">
                                    <span className="form-attribute">
                                      AI First Reason
                                    </span>
                                  </div>
                                  <div className="col-md-12">
                                    <textarea
                                      disabled
                                      value={this.state.ideasAI.AIReason}
                                      placeholder="Please provide value"
                                      className="form-input"
                                      rows={4}
                                      cols={80}
                                      style={{
                                        width: "100%",
                                        border: "1px solid lightgrey",
                                        resize: "none"
                                      }}
                                    />
                                  </div>
                                </div>
                                <div style={{ marginBottom: 20 }} />
                              </>
                              :
                              null
                          }


                          {/* <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>LDA</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="blackbelt" placeholder="Choose LDA" title={"OHR ID: " +  this.state.ideaItem.LDAOHR} value={this.state.ideaItem.LDA} />
                                                        </div>
                                                    </div> */}
                          <div style={{ marginBottom: 15 }} />
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px solid lightgrey",
                        marginBottom: 15,
                      }}
                    />

                    <p
                      className="visible-md-block visible-sm-block visible-xs-block"
                      style={{ marginTop: -25 }}
                    >
                      &nbsp;
                    </p>

                    <div
                      id="idea1"
                      className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                      style={{ marginTop: 15 }}
                    >
                      <div className="u-container-layout u-container-layout-7">
                        <div className="u-container-style u-group u-shape-rectangle u-group-8">
                          <div className="u-container-layout u-container-layout-8">
                            <p
                              id="idea1title"
                              className="u-align-left u-text u-text-2"
                              style={{ marginBottom: 10 }}
                            >
                              Idea details
                            </p>
                            <div className="row">
                              <div className="col-md-4">
                                <span className="form-attribute">
                                  Service Line
                                </span>
                              </div>
                              <div className="col-md-8">
                                <input
                                  className="form-input"
                                  disabled
                                  list="serviceline"
                                  name="serviceline"
                                  placeholder="Choose Service Line"
                                  value={this.state.ideaItem.ServiceLineName}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-4">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Sub Service Line
                                </label>{" "}
                              </div>
                              <div className="col-md-8">
                                <input
                                  className="form-input"
                                  disabled
                                  name="serviceline"
                                  placeholder="Choose Sub Service Line"
                                  value={this.state.ideaItem.SubServiceLine}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  What is the Problem ?
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <textarea
                                  className="form-input"
                                  disabled
                                  rows={6}
                                  cols={80}
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                  }}
                                  value={this.state.ideaItem.Problem}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="u-container-style u-group u-shape-rectangle u-group-9">
                          <div
                            className="u-container-layout u-container-layout-9"
                            style={{ marginTop: 4 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <span className="form-attribute">
                                  Idea Name
                                </span>
                              </div>
                              <div
                                className="col-md-8"
                                style={{ alignItems: "flex-start" }}
                              >
                                <input
                                  className="form-input"
                                  disabled
                                  type="text"
                                  value={this.state.ideaItem.IdeaName}
                                  placeholder="Eg: Cash flow improvement through process restructuring"
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 66 }} />
                            <p
                              className="u-align-left u-text u-text-custom-color-4 u-text-25"
                              style={{ width: "177px" }}
                            >
                              <span className="u-text-black form-attribute">
                                {" "}
                                How to resolve the problem
                              </span>
                              &nbsp;
                            </p>
                            <div className="row">
                              <div className="col-md-12">
                                <textarea
                                  className="form-input"
                                  disabled
                                  rows={6}
                                  cols={80}
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                  }}
                                  value={this.state.ideaItem.Solution}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: 20 }}>
                          <div className="col-md-5">
                            <span className="form-attribute">
                              Are you trying to replicate an existing Idea?
                            </span>
                          </div>
                          <div className="col-md-4">
                            <label className="switch">
                              <input
                                disabled
                                type="checkbox"
                                checked={
                                  this.state.ideaItem.NewOrReplicatedIdea ===
                                    null
                                    ? false
                                    : this.state.ideaItem.NewOrReplicatedIdea
                                }
                              />
                              <span className="slider round" />
                            </label>
                          </div>
                        </div>

                        {this.state.ideaItem.NewOrReplicatedIdea && (
                          <>
                            <div
                              className="col-md-8"
                              style={{ marginBottom: 15, width: "100%" }}
                            />
                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  Provide the ID of the executed Idea which you
                                  want to replicate?
                                </span>
                              </div>
                              <div className="col-md-2">
                                <input
                                  className="form-input"
                                  disabled
                                  type="text"
                                  value={
                                    this.state.ideaItem.ReplicationProjectId
                                  }
                                />
                              </div>
                            </div>
                          </>
                        )}

                        <div
                          className="col-md-8"
                          style={{ marginBottom: 15 }}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px solid lightgrey",
                        marginBottom: 15,
                      }}
                    />

                    <div
                      id="Approval Status"
                      className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                    >
                      <div className="u-container-layout u-container-layout-7">
                        <p
                          className="u-align-left u-text u-text-2"
                          style={{ marginBottom: 10 }}
                        >
                          Approval details
                        </p>
                        <div className="row">
                          <div className="col-md-2">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Approval Status
                            </label>
                          </div>
                          <div className="col-md-2">
                            <input
                              className="form-input"
                              disabled
                              name="Status"
                              value={
                                IDEA_APPROVED
                                  ? APPROVED
                                  : IDEA_REJECTED
                                    ? REJECTED
                                    : IDEA_SEND_BACK
                                      ? SENT_BACK
                                      : PENDING
                              }
                            />
                          </div>
                          {/* <div className="col-md-3"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Expected timeline for execution</label></div>
                                                    <div className="col-md-2">
                                                        <input disabled name="ExpectedDate" value={this.state.ideaItem.ExpectedFinishDate ? this.formatDateString(new Date(this.state.ideaItem.ExpectedFinishDate)) : ""} />
                                                    </div> */}
                        </div>
                        <div
                          className="col-md-9"
                          style={{ marginBottom: 5, width: "100%" }}
                        />
                        {/* <div className="row">
                                                    <div className="col-md-12">
                                                        <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                                            <span className="u-text-black form-attribute">Comments</span>
                                                        </p>
                                                    </div>
                                                </div> */}
                        {/* <div className="row" style={{marginBottom:15}}>
                                                    <div className="col-md-12">
                                                        <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.Comment} />
                                                    </div>
                                                </div> */}
                        <div className="row" style={{ marginTop: 15 }}>
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Comments
                            </label>
                          </div>
                          <div className="col-md-2" style={{ marginLeft: 20 }}>
                            <button
                              className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                              onClick={(e) =>
                                this.setState({
                                  commentLog: !this.state.commentLog,
                                })
                              }
                            >
                              Comment Log
                            </button>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: 5 }}>
                          <div className="col-md-12">
                            <textarea
                              className="form-input"
                              disabled
                              rows={3}
                              cols={88}
                              style={{
                                maxWidth: "100%",
                                border: "1px solid lightgrey",
                              }}
                              name="Comments"
                              value={this.state.ideaItem.Comment}
                            />
                          </div>
                        </div>
                        <div className="text-left mt-4">
                          {this.state.commentLog &&
                            this.state.reviewComments ? (
                            <>
                              <div className="custom_modal">
                                <div className="modal_body">
                                  <div className="row">
                                    <div className="col-md-8">
                                      <h3 className="modal_title">
                                        Idea Approval Comment Log
                                      </h3>
                                    </div>
                                    <div className="col-md-4">
                                      <button
                                        type="button"
                                        className="close text-right"
                                        onClick={(e) =>
                                          this.setState({ commentLog: false })
                                        }
                                      >
                                        &times;
                                      </button>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div
                                      className="col-md-2 text-center"
                                      style={{
                                        border: "1px solid lightgrey",
                                        backgroundColor: "gainsboro",
                                      }}
                                    >
                                      <label
                                        style={{
                                          fontWeight: 100,
                                          verticalAlign: "bottom",
                                        }}
                                      >
                                        Date & Time
                                      </label>
                                    </div>
                                    <div
                                      className="col-md-2 text-center"
                                      style={{
                                        border: "1px solid lightgrey",
                                        backgroundColor: "gainsboro",
                                      }}
                                    >
                                      <label
                                        style={{
                                          fontWeight: 100,
                                          verticalAlign: "bottom",
                                        }}
                                      >
                                        OHR
                                      </label>
                                    </div>
                                    <div
                                      className="col-md-2 text-center"
                                      style={{
                                        border: "1px solid lightgrey",
                                        backgroundColor: "gainsboro",
                                      }}
                                    >
                                      <label
                                        style={{
                                          fontWeight: 100,
                                          verticalAlign: "bottom",
                                        }}
                                      >
                                        Name
                                      </label>
                                    </div>
                                    <div
                                      className="col-md-1 text-center"
                                      style={{
                                        border: "1px solid lightgrey",
                                        backgroundColor: "gainsboro",
                                      }}
                                    >
                                      <label
                                        style={{
                                          fontWeight: 100,
                                          verticalAlign: "bottom",
                                        }}
                                      >
                                        Role
                                      </label>
                                    </div>
                                    <div
                                      className="col-md-2 text-center"
                                      style={{
                                        border: "1px solid lightgrey",
                                        backgroundColor: "gainsboro",
                                      }}
                                    >
                                      <label
                                        style={{
                                          fontWeight: 100,
                                          verticalAlign: "bottom",
                                        }}
                                      >
                                        Action
                                      </label>
                                    </div>
                                    <div
                                      className="col-md-3 text-center"
                                      style={{
                                        border: "1px solid lightgrey",
                                        backgroundColor: "gainsboro",
                                      }}
                                    >
                                      <label
                                        style={{
                                          fontWeight: 100,
                                          verticalAlign: "bottom",
                                        }}
                                      >
                                        Comment
                                      </label>
                                    </div>
                                  </div>
                                  {this.state.reviewComments.map(
                                    (item, index) => {
                                      return (
                                        <div className="row" key={index}>
                                          <div
                                            className="col-md-2 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                            }}
                                          >
                                            <label
                                              style={{
                                                lineheight: 2,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              {this.formatDateStringWithTime(
                                                new Date(item.CreatedDate)
                                              )}
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-2 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                            }}
                                          >
                                            <label
                                              style={{
                                                lineheight: 2,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              {item.UpdaterOHR}
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-2 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                            }}
                                          >
                                            <label
                                              style={{
                                                lineheight: 2,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              {item.UpdaterName}
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-1 text-center role_over_flow_class"
                                            style={{
                                              border: "1px solid lightgrey",
                                            }}
                                          >
                                            <label
                                              style={{
                                                lineheight: 2,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              {item.UpdaterRole
                                                ? item.UpdaterRole
                                                : item.Action ===
                                                  "Idea Updated by Admin" ||
                                                  item.Action ===
                                                  "Idea Reinitiated by Admin"
                                                  ? "Admin"
                                                  : item.Action ===
                                                    "Delegate Action"
                                                    ? "BB"
                                                    : item.UpdaterOHR ===
                                                      this.state.ideaItem
                                                        .BlackBeltUserId
                                                      ? "BB"
                                                      : item.UpdaterOHR ===
                                                        this.state.ideaItem.MBBOHR
                                                        ? "MBB"
                                                        : item.UpdaterOHR ===
                                                          this.state.ideaItem.OwnerOHR
                                                          ? "Idea Owner"
                                                          : "LDT"}
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-2 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                            }}
                                          >
                                            <label
                                              style={{
                                                lineheight: 2,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              {item.UpdaterAction
                                                ? item.UpdaterAction
                                                : item.Action ===
                                                  "Idea Reinitiated by Admin"
                                                  ? "Idea Reinitiated"
                                                  : item.Action ===
                                                    "Idea Updated by Admin"
                                                    ? item.WorkflowStatus !==
                                                      "Pending"
                                                      ? item.WorkflowStatus
                                                      : "Idea Updated"
                                                    : item.Action ===
                                                      "Delegate Action"
                                                      ? "Delegated"
                                                      : item.WorkflowStatus ===
                                                        "Pending"
                                                        ? "Discard Cancellation"
                                                        : item.WorkflowStatus}
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-3 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                            }}
                                          >
                                            <label
                                              style={{
                                                lineheight: 2,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              {item.Comment
                                                ? item.Comment
                                                : "-"}
                                            </label>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px solid lightgrey",
                        marginTop: 15,
                        marginBottom: 15,
                      }}
                    />

                    <div
                      id="Potential Impact"
                      className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                    >
                      <div className="u-container-layout u-container-layout-7" style={{ display: "flex", alignItems: "flex-start", padding: "30px", marginTop: "20px" }}>
                        <div className="u-container-style u-group u-shape-rectangle u-group-8">
                          <div className="u-container-layout">
                            <p
                              id="Potential Impact"
                              className="u-align-left u-text u-text-2"
                              style={{ marginBottom: "30px" }}
                            >
                              Additional details
                            </p>
                            <div className="row">
                              <div className="col-md-6">
                                <span className="form-attribute">
                                  LDT Lead Name
                                </span>
                              </div>
                              <div className="col-md-6">
                              <Select
                                    isSearchable={false}
                                    value={this.state.ldtSelectedOption}
                                    options={this.renderLeadOptions()}
                                    styles={this.state.selectStyle.ldtOHR}
                                    placeholder="Choose LDT Lead"
                                    onChange={this.handleLDTLeadOptionChange}
                                  />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />


                            {
                              this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST
                                && this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                ?
                                <>
                                  <div style={{ marginBottom: 15 }} />
                                  <div className="row d_flex_align_items_center">
                                    <div className="col-md-6">
                                      <span className="form-attribute">
                                        Is the solution feasible ?
                                      </span>
                                    </div>
                                    <div className="col-md-6">
                                      <input
                                        className="form-input"
                                        disabled
                                        value={this.state.IsSolnFeasibleValue}
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 15 }} />
                                  <div className="row d_flex_align_items_center">
                                    <div className="col-md-6">
                                      <span className="form-attribute">
                                        Solution Complexity
                                      </span>
                                    </div>
                                    <div className="col-md-6">
                                      <input
                                        className="form-input"
                                        disabled
                                        name="methodology"
                                        value={
                                          this.state.ideasAI.SolnComplexity
                                        }
                                      />
                                    </div>
                                  </div>


                                  <div style={{ marginBottom: 15 }} />
                                  <div className="row d_flex_align_items_center">
                                    <div className="col-md-6">
                                      <span className="form-attribute">
                                        Is the Idea replicable
                                      </span>
                                    </div>
                                    <div className="col-md-6">
                                      <input
                                        className="form-input"
                                        disabled
                                        value={this.state.isIdeaReplicable}
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 15 }} />

                                </>
                                :
                                null
                            }



                            {/* <div className="row">
                                                            <div className="col-md-6"><span className="form-attribute">Potential Impact (# of FTE)</span></div>
                                                            <div className="col-md-6">
                                                                <input className="form-input" disabled type="number" value={this.state.ideaItem.PotentialImpactFTE} placeholder={0} max={10} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        <div className="row">
                                                            <div className="col-md-6"><span className="form-attribute">Potential Impact ($)</span></div>
                                                            <div className="col-md-6">
                                                                <input className="form-input" disabled type="number" value={this.state.ideaItem.PotentialImpactDollar} placeholder={0.0} />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 5 }} />
                                                        <div className="u-align-left u-text u-text-custom-color-3" style={{ fontSize: 11, fontStyle: 'italic' }}>(If Potential Impact $ is greater than 250K OR FTE number is greater than 10, please review thoroughly)
                                                                </div> */}
                            <div style={{ marginBottom: 5 }} />
                            <div style={{ marginTop: 10, marginBottom: 14 }} />
                            {this.state.ideaItem.NewOrReplicatedIdea && (
                              <div className="row">
                                <div className="col-md-10">
                                  <label
                                    style={{
                                      verticalAlign: "bottom",
                                      marginBottom: -5,
                                    }}
                                  >
                                    <span style={{ color: "red" }}>*</span> Have
                                    you verified the replication id and confirm
                                    this to be replication project?
                                  </label>
                                </div>
                                <div className="col-md-2">
                                  <label className="switch">
                                    <input
                                      disabled
                                      type="checkbox"
                                      checked={
                                        this.state.ideaItem
                                          .IsReplicationVerified
                                      }
                                    />
                                    <span className="slider round" />
                                  </label>
                                </div>
                              </div>
                            )}

                            {
                              this.displayCoderSection() && (
                                <div className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ marginTop: 40 }}>
                                  <div className="u-container-layout u-container-layout-7" style={{ paddingTop: "0px" }}>
                                    <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}><span style={{ color: "red" }}>*&nbsp;</span>Coder Section</p>
                                    <span style={{ fontSize: "12px", color: "red" }}><i>Note: Minimum 1 OHR and Maximum 10 OHRs.</i></span>
                                    <div style={{ marginTop: "15px" }}>
                                      <div className="row">
                                        <div className="col-md-8">
                                          <input type="text" onChange={this.handleCoderOhrOnChange} onKeyDown={this.state.CodersTable.length <= 10 ? this.handleCoderOHRKeyDown : null} value={this.state.individualCoderOHR} placeholder="Enter coder's OHR" className="textarea-css form-attribute hide_numeric_arrows" />
                                        </div>
                                        <div className="col-md-4">
                                          <button onClick={this.handleCoderOHRAdd} disabled={this.state.CodersTable.length >= 10} className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3">Add</button>
                                        </div>
                                      </div>
                                      {
                                        this.state.CodersTable.length !== 0 &&
                                        <div className="VD_Summary" >
                                          <div className="row mt-3">
                                            <div className="col-md-7 col-xs-4 VD_Summary_table_header">
                                              <div className=""><label>Coder Name</label></div>
                                            </div>
                                            <div className="col-md-3 col-xs-4 VD_Summary_table_header">
                                              <div><label>Coder OHR</label></div>
                                            </div>
                                            <div className="col-md-2 col-xs-4 VD_Summary_table_header">
                                              <div style={{ display: 'grid', justifyContent: 'center' }}>
                                                <label>Delete</label>
                                              </div>
                                            </div>
                                          </div>
                                          {this.state.CodersTable && this.state.CodersTable.map((item, index) => {
                                            return (
                                              <>
                                                <div className="" key={index}>
                                                  <div className="row">
                                                    <div className="col-md-7 col-xs-4 VD_Summary_table_row">
                                                      <div style={{ marginTop: '2.5px' }}>
                                                        <label>{item.OHRName}</label>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-3   col-xs-4 VD_Summary_table_row">
                                                      <div style={{ marginTop: '2.5px' }}>
                                                        <label>{item.OHR}</label>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-2 col-xs-4 VD_Summary_table_row">
                                                      <div style={{ display: 'grid', justifyContent: 'center', marginTop: '2.5px' }} >
                                                        <button
                                                          title='Delete'
                                                          className="btn btn-danger cursor-pointer btn-sm u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2 p-3"
                                                          style={{ width: '23px', marginTop: '1.5px' }}
                                                          onClick={() => { this.handleCoderOHRdelete(index) }}
                                                        ><i className="fa fa-trash" aria-hidden="true"></i></button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            )
                                          })}
                                        </div>
                                      }

                                    </div>
                                    <div className="col-md-12" style={{ marginBottom: "15px" }} />
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        </div>

                        <div className="u-container-style u-group u-shape-rectangle " style={{ width: "513px" }}>
                          <div
                            className="u-container-layout u-container-layout-9"
                            style={{ paddingTop: "15px" }}
                          >
                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  &nbsp;&nbsp;Certification Level
                                </span>{" "}
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  name="certlevel"
                                  value={
                                    this.state.ideaItem.CertificationLevelName
                                  }
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />

                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  <span style={{ color: "red" }}>*&nbsp;</span>
                                  Transformation Lever
                                </span>{" "}
                              </div>
                              <div className="col-md-7">
                                {
                                  <Select
                                      isSearchable={false}
                                      options={this.renderTransLeversOptions()}
                                      value={this.state.transSelectedOption}
                                      styles={this.state.selectStyle.transSelectedOption}
                                      onChange={this.handleTransLeversChange}
                                      placeholder="Select Transformation Lever"
                                    />

                                }

                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />

                            {this.state.digitalProjectEnabled ? (
                              <>
                                <div style={{ marginBottom: 15 }} />
                                <div className="row">
                                  <div className="col-md-5">
                                    <label
                                      style={{
                                        verticalAlign: "bottom",
                                        marginBottom: -5,
                                      }}
                                    >
                                      <span style={{ color: "red" }}>*&nbsp;</span>
                                      Digital Project Type
                                    </label>{" "}
                                  </div>
                                  <div className="col-md-7">
                                    <Select
                                      isSearchable={false}
                                      options={this.renderDigitalProjectTypeOptions()}
                                      styles={this.state.selectStyle.digitalProjectTypeSelectedOptions}
                                      value={this.state.digitalProjectTypeSelectedOptions}
                                      onChange={this.handleDigitalProjectTypeChange}
                                      placeholder="Choose Project Type"
                                    />
                                  </div>
                                </div>
                              </>
                            ) : null}
                            <div style={{ marginBottom: 15 }} />



                            <div className="">
                              <div className="row">
                                <div className="col-md-5">
                                  <span className="form-attribute">
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    AI Classification
                                  </span>
                                </div>
                                <div className="col-md-7">
                                  <Select
                                    isSearchable={false}
                                    options={this.renderAIClassificationList()}
                                    value={this.state.aiClassificationListSelectedOption}
                                    styles={this.state.selectStyle.aiClassificationListSelectedOption}
                                    onChange={(e) => this.handleAIClassificationChange(e)}
                                    placeholder="Choose AI Classification"
                                  />
                                </div>
                              </div>
                              <div style={{ marginBottom: 15 }} />
                            </div>


                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  <span style={{ color: "red" }}>*&nbsp;</span>
                                  Tools/Methodology Used
                                </span>
                              </div>
                              <div className="col-md-7">
                                <div className="tools_methodologies_dropdown">
                                  <Select
                                    isSearchable={true}
                                    isMulti={true}
                                    options={this.renderMethodologyOptions()}
                                    value={this.state.methodologySelectedOptions}
                                    styles={this.state.selectStyle.methodologySelectedOptions}
                                    onChange={this.handleMethodologyChange}
                                    placeholder="Choose Methodologies"
                                    title={this.state.methodologySelectedOptions}
                                  />
                                </div>

                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <span className="form-attribute">
                                  <span style={{ color: "red" }}>&nbsp;&nbsp;</span>
                                  Other tools</span>
                              </div>
                              <div className="col-md-7">
                                <textarea
                                  rows='3'
                                  className="textarea-css form-attribute"
                                  style={{ border: "1px solid lightgrey", ...this.state.selectStyle.OtherTools, width: "100%" }}
                                  placeholder='Provide other tools'
                                  value={this.state.OtherTools}
                                  type="text"
                                  title={this.state.OtherTools ? this.state.OtherTools : ""}
                                  onChange={(e) => this.handleOtherToolsChange(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {this.state.ideaItem.ApprovalStatus &&
                      this.state.finalReviewComments && (
                        <>
                          <div
                            style={{
                              borderBottom: "1px solid lightgrey",
                              marginBottom: 15,
                            }}
                          />
                          <div
                            id="Approval Status"
                            className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                          >
                            <div className="u-container-layout u-container-layout-7">
                              <p
                                className="u-align-left u-text u-text-2"
                                style={{ marginBottom: 10 }}
                              >
                                Lean Approval details
                              </p>
                              <div className="row">
                                <div className="col-md-2">
                                  <span className="form-attribute">
                                    Approval Status
                                  </span>{" "}
                                </div>
                                <div className="col-md-2">
                                  <input
                                    className="form-input"
                                    disabled
                                    name="finalapprovalstatus"
                                    value={this.state.ideaItem.ApprovalStatus}
                                  />
                                </div>
                              </div>
                              <div className="row" style={{ marginTop: 15 }}>
                                <div className="col-md-5">
                                  <label
                                    style={{
                                      verticalAlign: "bottom",
                                      marginBottom: -5,
                                    }}
                                  >
                                    Approval Comments
                                  </label>
                                </div>
                                <div
                                  className="col-md-2"
                                  style={{ marginLeft: 20 }}
                                >
                                  <button
                                    className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                    onClick={(e) =>
                                      this.setState({
                                        finalCommentLog:
                                          !this.state.finalCommentLog,
                                      })
                                    }
                                  >
                                    Comment Log
                                  </button>
                                </div>
                              </div>
                              <div className="row" style={{ marginTop: 5 }}>
                                <div className="col-md-12">
                                  <textarea
                                    className="form-input"
                                    disabled
                                    rows={3}
                                    cols={88}
                                    style={{
                                      maxWidth: "100%",
                                      border: "1px solid lightgrey",
                                    }}
                                    name="Comments"
                                    value={this.state.ideaItem.FinalComments}
                                  />
                                </div>
                              </div>
                              <div className="text-left mt-4">
                                {this.state.finalCommentLog &&
                                  this.state.finalReviewComments ? (
                                  <>
                                    <div className="custom_modal">
                                      <div className="modal_body">
                                        <div className="row">
                                          <div className="col-md-8">
                                            <h3 className="modal_title">
                                              Lean Approval Comment Log
                                            </h3>
                                          </div>
                                          <div className="col-md-4">
                                            <button
                                              type="button"
                                              className="close text-right"
                                              onClick={(e) =>
                                                this.setState({
                                                  finalCommentLog: false,
                                                })
                                              }
                                            >
                                              &times;
                                            </button>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div
                                            className="col-md-2 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                              backgroundColor: "gainsboro",
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontWeight: 100,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              Date & Time
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-2 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                              backgroundColor: "gainsboro",
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontWeight: 100,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              OHR
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-2 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                              backgroundColor: "gainsboro",
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontWeight: 100,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              Name
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-1 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                              backgroundColor: "gainsboro",
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontWeight: 100,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              Role
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-2 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                              backgroundColor: "gainsboro",
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontWeight: 100,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              Action
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-3 text-center"
                                            style={{
                                              border: "1px solid lightgrey",
                                              backgroundColor: "gainsboro",
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontWeight: 100,
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              Comment
                                            </label>
                                          </div>
                                        </div>
                                        {this.state.finalReviewComments.map(
                                          (item, index) => {
                                            return (
                                              <div className="row" key={index}>
                                                <div
                                                  className="col-md-2 text-center"
                                                  style={{
                                                    border:
                                                      "1px solid lightgrey",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      lineheight: 2,
                                                      verticalAlign: "bottom",
                                                    }}
                                                  >
                                                    {this.formatDateStringWithTime(
                                                      new Date(item.CreatedDate)
                                                    )}
                                                  </label>
                                                </div>
                                                <div
                                                  className="col-md-2 text-center"
                                                  style={{
                                                    border:
                                                      "1px solid lightgrey",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      lineheight: 2,
                                                      verticalAlign: "bottom",
                                                    }}
                                                  >
                                                    {item.UpdaterOHR}
                                                  </label>
                                                </div>
                                                <div
                                                  className="col-md-2 text-center"
                                                  style={{
                                                    border:
                                                      "1px solid lightgrey",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      lineheight: 2,
                                                      verticalAlign: "bottom",
                                                    }}
                                                  >
                                                    {item.UpdaterName}
                                                  </label>
                                                </div>
                                                <div
                                                  className="col-md-1 text-center"
                                                  style={{
                                                    border:
                                                      "1px solid lightgrey",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      lineheight: 2,
                                                      verticalAlign: "bottom",
                                                    }}
                                                  >
                                                    {item.UpdaterRole
                                                      ? item.UpdaterRole
                                                      : item.Action ===
                                                        "Idea Updated by Admin" ||
                                                        item.Action ===
                                                        "Idea Reinitiated by Admin"
                                                        ? "Admin"
                                                        : item.Action ===
                                                          "Idea was reviewed by MBB"
                                                          ? "MBB"
                                                          : item.Action ===
                                                            "Idea was reviewed by LDT"
                                                            ? "LDT"
                                                            : item.UpdaterOHR ===
                                                              this.state.ideaItem
                                                                .OwnerOHR
                                                              ? "Idea Owner"
                                                              : "BB"}
                                                  </label>
                                                </div>
                                                <div
                                                  className="col-md-2 text-center"
                                                  style={{
                                                    border:
                                                      "1px solid lightgrey",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      lineheight: 2,
                                                      verticalAlign: "bottom",
                                                    }}
                                                  >
                                                    {item.UpdaterAction ? item.UpdaterAction : item.Action === "Idea Reinitiated by Admin" ? "Idea Reinitiated" : item.Action === "Idea Updated by Admin"
                                                      ? item.ApprovalStatus : item.WorkflowStatus === COMPLETE_STATUS || item.WorkflowStatus === "Approve" || item.WorkflowStatus === "Approved"
                                                        ? "Approved"
                                                        : item.WorkflowStatus ===
                                                          "Rejected" ||
                                                          item.WorkflowStatus ===
                                                          "Reject"
                                                          ? "Rejected"
                                                          : item.WorkflowStatus ===
                                                            AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                                                            ? AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                                                            : item.WorkflowStatus ===
                                                              "Pending Documents"
                                                              ? "Discard Cancellation"
                                                              : item.WorkflowStatus ===
                                                                CANCEL
                                                                ? CANCEL
                                                                : "Sent Back"}
                                                  </label>
                                                </div>
                                                <div
                                                  className="col-md-3 text-center"
                                                  style={{
                                                    border:
                                                      "1px solid lightgrey",
                                                  }}
                                                >
                                                  <label
                                                    style={{
                                                      lineheight: 2,
                                                      verticalAlign: "bottom",
                                                    }}
                                                  >
                                                    {item.Comment
                                                      ? item.Comment
                                                      : "-"}
                                                  </label>
                                                </div>
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    <div
                      style={{
                        borderBottom: "1px solid lightgrey",
                        marginBottom: 15,
                      }}
                    />

                    

                    {this.state.impactOptionSelected ? (
                      <>
                        <div
                          id="Potential Impact"
                          className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                        >
                          <div
                            className="u-container-layout u-container-layout-7"
                            style={{
                              borderBottom: "1px solid lightgray",
                              paddingBottom: "35px",
                              marginBottom: "20px",
                            }}
                          >
                            <div className="u-container-style u-group u-shape-rectangle u-group-8">
                              <div className="u-container-layout u-container-layout-8">
                                <p
                                  id="Potential Impact"
                                  className="u-align-left u-text u-text-2"
                                  style={{ marginBottom: 10 }}
                                >
                                  Final additional details
                                </p>
                                <div className="row">
                                  <div className="col-md-6">
                                    <span className="form-attribute">
                                      <span style={{ color: "red" }}> *</span>{" "}
                                      Final Impact (# of FTE)
                                    </span>{" "}
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      className="form-input"
                                      disabled
                                      type="number"
                                      value={this.state.finalImpactFTE}
                                      placeholder={0}
                                      max={10}
                                      style={{
                                        ...this.state.selectStyle
                                          .FinalImpactFTE,
                                      }}
                                    />
                                  </div>
                                </div>
                                <div style={{ marginBottom: 15 }} />
                                <div className="row">
                                  <div className="col-md-6">
                                    <span className="form-attribute">
                                      <span style={{ color: "red" }}>*</span>{" "}
                                      Final Impact ($)
                                    </span>{" "}
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      className="form-input"
                                      disabled
                                      type="number"
                                      value={this.state.finalImpactDollar}
                                      placeholder={0.0}
                                      style={{
                                        ...this.state.selectStyle
                                          .FinalImpactDollar,
                                      }}
                                    />
                                  </div>
                                </div>
                                <div style={{ marginBottom: 5 }} />
                                <div
                                  className="u-align-left u-text u-text-custom-color-3"
                                  style={{ fontSize: 11, fontStyle: "italic" }}
                                >
                                  (If Final Impact $ is greater than 250K OR
                                  Final FTE number is greater than 10, please
                                  review thoroughly)
                                </div>
                                <div
                                  style={{ marginTop: 5, marginBottom: 15 }}
                                />
                                <div className="row">
                                  <div className="col-md-5">
                                    <span className="form-attribute">
                                      <span style={{ color: "red" }}>*</span> Is
                                      it a Zero Impact Project
                                    </span>
                                  </div>
                                  <div className="col-md-6">
                                    <label className="switch">
                                      <input
                                        type="checkbox"
                                        id="isZeroImpactProject"
                                        checked={this.state.impactOptionSelected?.label === NO_VD ? true : false}
                                      />
                                      <span className="slider round" />
                                    </label>
                                  </div>
                                </div>
                                <div style={{ marginBottom: 22 }} />
                              </div>
                            </div>
                            <p
                              className="visible-md-block visible-sm-block visible-xs-block"
                              style={{ marginTop: 22 }}
                            >
                              &nbsp;
                            </p>
                            <div className="u-container-style u-group u-shape-rectangle u-group-9">
                              <div
                                className="u-container-layout u-container-layout-9"
                                style={{ marginTop: 90, marginBottom: 36 }}
                              >
                                <p
                                  className="visible-md-block visible-sm-block visible-xs-block"
                                  style={{ marginTop: "-100px" }}
                                >
                                  &nbsp;
                                </p>
                                <div className="row">
                                  <div className="col-md-5">
                                    <span className="form-attribute">
                                      <span style={{ color: "red" }}>*</span>{" "}
                                      Best in Class
                                    </span>
                                  </div>
                                  <div className="col-md-6">
                                    <label className="switch best_in_class_slider">
                                      <input
                                        type="checkbox"
                                        id="isReplicationIdeaBtn"
                                        checked={this.state.bestClass}
                                        value={this.state.bestClass}
                                        onClick={this.handleClassChange}
                                      />
                                      <span className="slider round" />
                                    </label>
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: 15 }}>
                                  <div className="col-md-5">
                                    <span
                                      style={{ cursor: "pointer" }}
                                      className="form-attribute"
                                      title="Replicability Index is the measure of ‘ease of replication’ or ‘how easily can this same project be implemented’ in another Account. The higher the rating, the easier it is to replicate in another account and vice versa."
                                    >
                                      <span style={{ color: "red" }}>*</span>{" "}
                                      Replicability Index
                                    </span>{" "}
                                  </div>
                                  <div className="col-md-6">
                                    <Select
                                      isSearchable={false}
                                      options={REPLICABILITYOPTIONS}
                                      value={this.state.replicaIndex}
                                      styles={
                                        this.state.selectStyle.replicaIndex
                                      }
                                      placeholder="Choose replicabilty index"
                                      onChange={(e) => this.replicaIndexChangeHandler(e)}
                                    />
                                  </div>
                                </div>
                                <div style={{ marginBottom: 15 }} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}

                    {this.state.ideaItem.CertificationLevelName === "Lean" &&
                      this.state.ideaItem.IdeaId && this.state.businessImpactMasterList? (
                      <>
                        <ValueDelivery
                          IdeaData = {this.state.ideaItem}
                          vdForComponent={this.state.vdForComponent}
                          BIMasterDataVerseNew={this.state.businessImpactMasterList}
                          func={this.pull_data}
                          viewIdea={false}
                          vdType={this.handleVDTypeChange}
                          IdeaId={this.state.ideaItem.IdeaId}
                          fetchMonetizationFileDetails={this.pull_file_data}
                          bbMonetizationTotal={this.pull_monetizedTotal}
                          monetizableProject={this.pull_monetizableProject}
                          monetizableStatus={this.pull_monetizableStatus}
                          fetchFPAOHRforIncreaseInRevenue={this.fetchFPAOHRforIncreaseInRevenue}
                          bbMonetizationApproval={false}
                          postFpnaValid={false}
                          fetchMonetizationSowID={this.pull_monetization_sowId}
                          fetchDeletedBIRows={this.remove_bi_data_after_delete}
                          fetchMonetizationFpnaOhr={this.pull_monetization_fpna_ohr}
                          fetchMonetizationFpnaName={this.pull_monetization_fpna_name}
                          fetchMonetizationGOLName={this.pullMonetizationGOLName}
                          fetchMonetizationGOLOhr={this.pullMonetizationGOLOhr}
                          fetchCategoryNotListed={this.pullCategoryNotListed}

                          fetchPPTDeck={this.pullPPTDeck}
                          fetchClientDocName={this.pullClientDocName}
                          fetchClientDocType={this.pullClientDocType}
                          fetchClientDocContent={this.pullClientDocContent}
                          fetchGolDocName={this.pullgolFileName}
                          fetchGolDocType={this.pullgolFileType}
                          fetchGolDocContent={this.pullgolContent}
                          fetchfpnaDocName={this.pullfpnafileName}
                          fetchfpnaDocType={this.pullfpnafileType}
                          fetchfpnaDocContent={this.pullfpnafileContent}
                          fetchClientName={this.pullClientName}
                          fetchClientRole={this.pullClientRole}
                          fetchClientSignOffDate={this.pullClientSignOff}
                          fetchFpnaName={this.pullFpnaName}
                          fetchGolName={this.pullGolName}
                          fetchFpnaOhr={this.pullFpnaOhr}
                          fetchGolOhr={this.pullGolOhr}
                          fetchFileDetails={this.pull_fileDetails}

                          


                        />
                        {
                          this.state.impactOptionSelected && this.state.impactOptionSelected.label === NO_VD
                            ?
                            <>

                            </>
                            :
                            <div className="" style={{ borderBottom: "1px solid lightgrey" }} />
                        }

                      </>
                    ) : null}

                    {this.state.ideaItem.QCName && this.state.ideaItem.QCOHR ? (
                      <>
                        <div
                          id="Approval Status"
                          className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                        >
                          <div
                            className="u-container-layout u-container-layout-7"
                            style={{
                              borderBottom: " 1px solid lightgray",
                              paddingTop: "40px",
                            }}
                          >
                            <p
                              className="u-align-left u-text u-text-2"
                              style={{ marginBottom: 10 }}
                            >
                              Quality Check Details Approval
                            </p>
                            <div className="row" style={{ marginTop: 15 }}>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: "-13px",
                                  }}
                                >
                                  Approval Comments
                                </label>
                              </div>
                              <div
                                className="col-md-2"
                                style={{ marginLeft: 20 }}
                              >
                                <button
                                  className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                  onClick={(e) =>
                                    this.setState({ qcCommentLog: true })
                                  }
                                >
                                  Comment Log
                                </button>
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: 5 }}>
                              <div className="col-md-12">
                                <textarea
                                  className="form-input"
                                  disabled
                                  rows={3}
                                  cols={88}
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                  }}
                                  name="Comments"
                                  value={this.state.ideaItem.FinalComments}
                                />
                              </div>
                            </div>
                            <div className="text-left mt-4">
                              {this.state.qcCommentLog &&
                                this.state.qcComments.length > 0 ? (
                                <>
                                  <div className="custom_modal">
                                    <div className="modal_body">
                                      <div className="row">
                                        <div className="col-md-8">
                                          <h3 className="modal_title">
                                            QC Comment Log
                                          </h3>
                                        </div>
                                        <div className="col-md-4">
                                          <button
                                            type="button"
                                            className="close text-right"
                                            onClick={(e) =>
                                              this.setState({
                                                qcCommentLog: false,
                                              })
                                            }
                                          >
                                            &times;
                                          </button>
                                        </div>
                                      </div>

                                      <div className="qc_responsive_comment_log">
                                        <div className="table table-responsive table-bordered">
                                          <thead className="text-center">
                                            <tr>
                                              <th className="qcHeaderbg qcVDHeader">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Date & Time
                                                </label>
                                              </th>
                                              <th className="qcHeaderbg qcVDHeader">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  OHR
                                                </label>
                                              </th>
                                              <th className="qcHeaderbg qcVDHeader">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Name
                                                </label>
                                              </th>
                                              <th className="qcHeaderbg qcVDHeader">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Role
                                                </label>
                                              </th>
                                              <th className="qcHeaderbg qcVDHeader">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Action
                                                </label>
                                              </th>
                                              <th
                                                className="qcHeaderbg"
                                                style={{ minWidth: "250px" }}
                                              >
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Comment
                                                </label>
                                              </th>
                                              <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthOne">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Is the impact correctly tagged
                                                  to Genpact or Client ?
                                                </label>
                                              </th>
                                              <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthTwo">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Has the Value Delivery been
                                                  correctly categorized ?
                                                </label>
                                              </th>
                                              <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthThree">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Has the Value Delivery been
                                                  computed correctly ?
                                                </label>
                                              </th>
                                              <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthFour">
                                                <label
                                                  style={{
                                                    fontWeight: 100,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period ?
                                                </label>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.qcComments.map(
                                              (item, index) => {
                                                return (
                                                  <tr key={index}>
                                                    <td>
                                                      <label
                                                        style={{
                                                          lineheight: 2,
                                                          verticalAlign:
                                                            "bottom",
                                                        }}
                                                      >
                                                        {this.formatDateStringWithTime(
                                                          new Date(
                                                            item.CreatedDate
                                                          )
                                                        )}
                                                      </label>
                                                    </td>
                                                    <td>
                                                      <label
                                                        style={{
                                                          lineheight: 2,
                                                          verticalAlign:
                                                            "bottom",
                                                        }}
                                                      >
                                                        {item.UpdaterOHR}
                                                      </label>
                                                    </td>
                                                    <td>
                                                      <label
                                                        style={{
                                                          lineheight: 2,
                                                          verticalAlign:
                                                            "bottom",
                                                        }}
                                                      >
                                                        {item.UpdaterName}
                                                      </label>
                                                    </td>
                                                    <td>
                                                      <label
                                                        style={{
                                                          lineheight: 2,
                                                          verticalAlign:
                                                            "bottom",
                                                        }}
                                                      >
                                                        {item.UpdaterRole
                                                          ? item.UpdaterRole
                                                          : item.Action ===
                                                            "Idea Updated by Admin" ||
                                                            item.Action ===
                                                            "Idea Reinitiated by Admin"
                                                            ? "Admin"
                                                            : item.Action ===
                                                              "Delegate Action"
                                                              ? "BB"
                                                              : item.UpdaterOHR ===
                                                                this.state.MBBOHR
                                                                ? "MBB"
                                                                : item.UpdaterOHR ===
                                                                  this.state.ideaItem
                                                                    .OwnerOHR
                                                                  ? "Idea Owner"
                                                                  : item.ApprovalStatus ===
                                                                    "Pending Documents" &&
                                                                    item.WorkflowStatus ===
                                                                    "Approved"
                                                                    ? "BB"
                                                                    : item.ApprovalStatus ===
                                                                      "NA" &&
                                                                      item.WorkflowStatus ===
                                                                      "Pending"
                                                                      ? "BB"
                                                                      : item.UpdaterRole}
                                                      </label>
                                                    </td>
                                                    <td>
                                                      {/* <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.ApprovalStatus==="Documents Uploaded" ? "Send Back" : ((item.WorkflowStatus==="Rejected" || item.WorkflowStatus==="Reject" || item.ApprovalStatus==="Reject" || item.ApprovalStatus==="Rejected" )? "Rejected ":"Approved")}</label> */}
                                                      <label
                                                        style={{
                                                          lineheight: 2,
                                                          verticalAlign:
                                                            "bottom",
                                                        }}
                                                      >
                                                        {item.UpdaterAction
                                                          ? item.UpdaterAction
                                                          : item.ApprovalStatus ===
                                                            "Documents Uploaded"
                                                            ? "Send Back"
                                                            : item.WorkflowStatus ===
                                                              "Rejected" ||
                                                              item.WorkflowStatus ===
                                                              "Reject" ||
                                                              item.ApprovalStatus ===
                                                              "Reject" ||
                                                              item.ApprovalStatus ===
                                                              "Rejected"
                                                              ? "Rejected "
                                                              : item.Action ===
                                                                "Idea was Rework - QC"
                                                                ? "Rework"
                                                                : "Approved"}
                                                      </label>
                                                    </td>
                                                    <td>
                                                      <label
                                                        style={{
                                                          lineheight: 2,
                                                          verticalAlign:
                                                            "bottom",
                                                        }}
                                                      >
                                                        {item.Comment !== ""
                                                          ? item.Comment
                                                          : "-"}
                                                      </label>
                                                    </td>
                                                    {this.state
                                                      .qcCommentsWithVD &&
                                                      this.state.qcCommentsWithVD
                                                        .length > 0 ? (
                                                      <>
                                                        {this.state.qcCommentsWithVD.map(
                                                          (pg_item) => {
                                                            if (
                                                              Number(
                                                                pg_item.ProjectTeamID
                                                              ) === item.TrackId
                                                            ) {
                                                              return (
                                                                <>
                                                                  <td>
                                                                    <label
                                                                      style={{
                                                                        lineheight: 2,
                                                                        verticalAlign:
                                                                          "bottom",
                                                                      }}
                                                                    >
                                                                      {JSON.parse(
                                                                        pg_item.AuditDataJSON
                                                                      )
                                                                        .pg_isvdimpacttagged
                                                                        ? JSON.parse(
                                                                          pg_item.AuditDataJSON
                                                                        )
                                                                          .pg_isvdimpacttagged
                                                                        : "-"}
                                                                    </label>
                                                                  </td>
                                                                  <td>
                                                                    <label
                                                                      style={{
                                                                        lineheight: 2,
                                                                        verticalAlign:
                                                                          "bottom",
                                                                      }}
                                                                    >
                                                                      {JSON.parse(
                                                                        pg_item.AuditDataJSON
                                                                      )
                                                                        .pg_isvdcategorized
                                                                        ? JSON.parse(
                                                                          pg_item.AuditDataJSON
                                                                        )
                                                                          .pg_isvdcategorized
                                                                        : "-"}
                                                                    </label>
                                                                  </td>
                                                                  <td>
                                                                    <label
                                                                      style={{
                                                                        lineheight: 2,
                                                                        verticalAlign:
                                                                          "bottom",
                                                                      }}
                                                                    >
                                                                      {JSON.parse(
                                                                        pg_item.AuditDataJSON
                                                                      )
                                                                        .pg_isvdcomputed
                                                                        ? JSON.parse(
                                                                          pg_item.AuditDataJSON
                                                                        )
                                                                          .pg_isvdcomputed
                                                                        : "-"}
                                                                    </label>
                                                                  </td>
                                                                  <td>
                                                                    <label
                                                                      style={{
                                                                        lineheight: 2,
                                                                        verticalAlign:
                                                                          "bottom",
                                                                      }}
                                                                    >
                                                                      {JSON.parse(
                                                                        pg_item.AuditDataJSON
                                                                      )
                                                                        .pg_isvdclientsignoff
                                                                        ? JSON.parse(
                                                                          pg_item.AuditDataJSON
                                                                        )
                                                                          .pg_isvdclientsignoff
                                                                        : "-"}
                                                                    </label>
                                                                  </td>
                                                                </>
                                                              );
                                                            }
                                                          }
                                                        )}
                                                      </>
                                                    ) : (
                                                      <>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            -
                                                          </label>
                                                        </td>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            -
                                                          </label>
                                                        </td>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            -
                                                          </label>
                                                        </td>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            -
                                                          </label>
                                                        </td>
                                                      </>
                                                    )}
                                                  </tr>
                                                );
                                              }
                                            )}
                                          </tbody>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}



                    <div
                      className="gol_fields_block text-left"
                      style={{ borderBottom: "0px", marginTop: "20px" }}
                    >
                      <p
                        className="u-align-left u-text u-text-2"
                        style={{ margin: "10px 0px 10px" }}
                      >
                        Approval Section
                      </p>
                      <div className="row">
                        <div className="col-md-10">
                          <div className="row">
                            <div className="col-md-10 gol_field_div text-left">
                              <span className="form-attribute">
                                <span style={{ color: "red" }}>* </span>
                                I acknowledge that I have reviewed the value delivery and I agree with the value apportioning between Client/Genpact, categorization and computation along with the necessary approvals recorded on this project ?
                              </span>
                            </div>
                            <div className="col-md-2">
                              <Select
                                styles={
                                  this.state.selectStyle.showBBFieldsValidation
                                }
                                options={YESORNO}
                                onChange={(e) => this.showBBFields(e)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      id="Approval Status"
                      className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                    >
                      <div
                        className="u-container-layout u-container-layout-7"
                        style={{
                          borderTop: "1px solid lightgray",
                          marginBottom: "20px",
                          paddingTop: "37px",
                        }}
                      >
                        <p
                          className="u-align-left u-text u-text-2"
                          style={{ marginBottom: 10 }}
                        >
                          Approval details
                        </p>
                        <div className="row d_flex_align_items_center ">
                          <div className="col-md-2">
                            <span className="form-attribute">
                              <span style={{ color: "red" }}>*</span> Approval
                              Status
                            </span>{" "}
                          </div>
                          <div className="col-md-2">
                            <Select
                              isSearchable={false}
                              options={this.renderStatusOptions()}
                              value={this.state.approvalSelectedOption}
                              placeholder="Choose Status"
                              onChange={this.handleApprovalStatus}
                              styles={
                                this.state.selectStyle.approvalSelectedOption
                              }
                            />
                          </div>
                        </div>
                        <div
                          className="col-md-8"
                          style={{ marginBottom: 5, width: "100%" }}
                        />
                        <div className="row">
                          <div className="col-md-7">
                            <div className="row">
                              <div className="col-md-11">
                                <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                  <span className="u-text-black form-attribute">
                                    <span style={{ color: "red" }}>*</span>
                                    &nbsp;Approval Comments
                                    <span
                                      style={{
                                        fontWeight: "normal",
                                        fontSize: 12,
                                        fontStyle: "italic",
                                        color: "grey",
                                      }}
                                    >&nbsp;
                                      (max. 500 chars)
                                    </span>
                                  </span>
                                </p>
                              </div>
                              <div
                                className="col-md-1"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  onClick={(e) =>
                                    this.toggleTranscriptFunction(7)
                                  }
                                  src={require("../assets/images/voice.png")}
                                  className="w100"
                                  alt=""
                                  style={{ width: "24px", cursor: "pointer" }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            {this.state.CommentEmpty ? (
                              <textarea
                                className="textarea-css form-attribute"
                                style={{
                                  maxWidth: "100%",
                                  border: "1px solid lightgrey",
                                  ...this.state.selectStyle.finalComment,
                                }}
                                rows={3}
                                cols={88}
                                placeholder="Please provide your comments in support of the Approval decision."
                                onChange={this.handleFinalCommentChange}
                                value={this.state.finalComment}
                              />
                            ) : (
                              <textarea
                                className="textarea-css form-attribute"
                                style={{
                                  maxWidth: "100%",
                                  border: "1px solid lightgrey",
                                  ...this.state.selectStyle.finalComment,
                                }}
                                rows={3}
                                cols={88}
                                placeholder="Please provide your comments in support of the Approval decision."
                                onChange={this.handleFinalCommentChange}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      {this.state.speechModal ? (
                        <UpdatedSpeech
                          modalOpen={true}
                          onFinalApprovalComment={
                            this.handleTranscriptFinalApprovalComment
                          }
                          modalId={this.state.modalIndex}
                          closeModalFunction={this.closeModalFunction}
                          previousText={this.state.previousTextForSpeech}
                        />
                      ) : null}
                    </div>

                    {this.state.showHrefModal ? (
                      <>
                        <div className="custom_modal href_modal">
                          <div className="modal_body href_modal_body">
                            <div className="href_modal_dialog">
                              <p>
                                To add a new category please raise a Helpmate
                                ticket, Click here to View SOP
                              </p>
                              <div className="href_modal_body_buttons">
                                <div className="btn-group href_modal_body_buttons">
                                  <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3">
                                    <a
                                      href="https://genpactonline.sharepoint.com/:b:/r/sites/LeanDigitalTransformation/Documents/KM%20Page%20-%202021/Certification%20Guidelines,%20SOPs%20%26%20Handbooks/Certification%20guidelines,%20SOPs%20%26%20Handbooks/Systems%20%26%20Tools/Helpmate-Data%20Related%20Request/ProGEAR%20Value%20Delivery%20Category%20Addition%20SOP.pdf?csf=1&web=1&e=5kKbFg"
                                      style={{ color: "#FFF" }}
                                      target="_blank"
                                    >
                                      Click Here
                                    </a>
                                  </button>
                                  <button
                                    className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6"
                                    onClick={(e) =>
                                      this.setState({ showHrefModal: false })
                                    }
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}
                    <div
                      style={{
                        borderBottom: "1px solid lightgrey",
                        marginTop: 10,
                        marginBottom: 15,
                      }}
                    />



                    {
                      this.state.backFillPopup 
                        ?
                        <div className="final_review_idea_page">
                          <div className="no_backfill_modal_overlay"></div>
                          <div className="productivity_admin_upload_recheck_model no_backfill_popup">
                            <div className="modal_body">
                              <label style={{textAlign: "left",wordBreak: "break-word"}}><b><u>Attention:</u></b> No OHR is uploaded against the given value delivery. Please note that to claim productivity, The released OHR should be tagged against at least 1 Project. <br></br>Do you want to approve this project without tagging an OHR on Global Productivity Module ?</label>
                              <div className="btn_inner_lock">
                                <button title="Click to upload template" className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 productivity_upload_template_label" onClick={() => this.handleProductivityPopupAction(true)}>Approve Anyway</button>
                                <button className="u-active-custom-color-6 u-border-2 u-btn u-btn-round u-radius-6 update_parent_btn" onClick={() => this.handleProductivityPopupAction(false)}>Pause Approval</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        :
                        null
                    }

                    {
                      this.state.FTEPopup
                        ?
                        <>

                          <div className="final_review_idea_page">
                            <div className="no_backfill_modal_overlay"></div>
                            <div className="productivity_admin_upload_recheck_model no_backfill_popup">
                              <div className="modal_body">
                                <label style={{ textAlign: "left", wordBreak: "break-word", color:"red" }}><b><u>Warning:</u></b> No OHR uploaded against this productivity hence the productivity calculated against this project might be considered as 0.</label>
                                <div className="btn_inner_lock">
                                  <button title="Click to upload template" className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 productivity_upload_template_label" onClick={(e) =>this.handleFTEProductivityPopupAction(true)}>Approve Without OHR upload</button>
                                  <button className="u-active-custom-color-6 u-border-2 u-btn u-btn-round u-radius-6 update_parent_btn" onClick={(e) => this.handleFTEProductivityPopupAction(false)}>Go back and Upload OHR</button>
                                </div>
                              </div>
                            </div>
                          </div>

                        </>
                        :
                        null
                    }


                    <div className="btn-group" style={{ marginTop: 15 }}>
                      <button
                        className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                        onClick={(e) =>
                          this.state.submitIdeaCount === 0
                            ? this.submitIdea()
                            : this.setState({
                              submitIdeaCount: this.state.submitIdeaCount + 1,
                            })
                        }
                      >
                        Submit
                      </button>
                      <button
                        className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6"
                        onClick={this.cancelEvent}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default FinalReviewIdeaPage;
